module.exports = {
  flags: {
    previewCheckFlag: 'OFF',
    peFlag: 'ON',
    dropAtStoreFlag: 'ON',
    codCustomMessage: 'For hassle free, safe and contactless delivery pay online',
    pickFromStoreFlag: 'ON',
    showStorePickUpTab: 'ON',
    dropAtStoreBanner: 'Available in select Trends stores in certain cities',
    pickFromStoreBanner:
      'Please note this service is available in select Trends stores in select cities across India.',
    loggerVerbosityFlag: 'OFF',
    chatWithUsFlag: 'ON',
    callMeBackFlag: 'ON',
    markAsDeliveredFlag: 'OFF',
    plpSizesFlag: 'ON',
    newSizeRevampFlag: 'OFF',
    showBrandSizeFlag: 'OFF',
    newSizeRevampDesktopFlag: 'OFF',
    showBrandSizeDesktopFlag: 'OFF',
    sizeRecommendFlag: 'OFF',
    sizeRecommendAppFlag: 'ON',
    otp_popup_display_mobile: true,
    otp_popup_display_email: false,
    haptikInitSettings: JSON.stringify({
      'business-id': '1107',
      'client-id': '5a6d4dd2948b967b87acfb5bc77950a21e92d2a7',
      'api-key': 'ajio:fe7bd11457cab57c00057d2eb83e0f38b0e97e0c',
      'base-url': 'https://jio-api.hellohaptik.com/',
      'custom-css': 'https://assets-uat.ajio.ril.com/static/assets/static/css/custom-haptic.css', // "http://localhost:3000/css/custom-haptic.css"
      'custom-button': true,
      'signup-type': 'ajio',
      'primary-color': '#2c4152',
      'secondary-color': '#ffffff',
      'header-icon': 'https://assets-jiocdn.ajio.com/static/img/ajio.png'
    }),
    haptikSrcUrl: 'https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js',
    fsWhiteListUrls: [
      '/healthcheck',
      '/login',
      '/static/assets',
      '/sw',
      '/api/auth',
      '/api/cart',
      '/api/my-account/banner-info',
      '/signup',
      '/password',
      '/order/confirm',
      '/order/retrypayment',
      '/payment-redirect',
      '/manifest.json',
      '/favicon.ico',
      '/selfcare',
      '/help',
      '/offline',
      '/service-worker.js',
      '/swassets',
      '/api/getFlashsaleTime',
      '/api/isRedirect'
    ],
    enableFlashSale: 'OFF',
    getSaleTimeTtl: 1.8e6,
    enableCatNavSec: 'ON',
    sizeGuideTimeout: 2000,
    pdpAggregatorTimeout: 3000,
    jewelReturnMessageFlag: 'OFF',
    jewelReturnModalMessage:
      'Once the product is returned to us we will do the quality check(QC) of the product, product must be in unused conditions with no sign of wear and tear, if QC fails refund will not be processed. If QC pass then refund will be provided to mode of payment.',
    showCustomerCareContactNumber: 'ON',
    showCustomerCareEmailId: 'ON',
    customerCareEmailId: 'customercare@ajio.com',
    customerCareContactNumber: '1800-889-9991',
    wrongProductDeliveredOptions: [
      {
        reason: 'Wrong Item Shipped',
        subReasons: ['Wrong Color Delivered', 'Delivered wrong size']
      }
    ],
    paymentMsg: 'We have served 11 Million+ happy customers across India.',
    unisexLandingPageId: '/shop/men',
    unisexMyJioLandingPageId: '/shop/women',
    runtimeBannersSis: 'ON',
    runtimeBannersMsiteSis: 'ON',
    runtimeBanners: 'ON',
    runtimeBannersMsite: 'ON',
    // Note: Empty list => All pages from CMS.
    runtimeBannersUrlList: [
      '/shop/ajio-own',
      '/shop/fresh-arrivals',
      '/shop/indie',
      '/shop/stores',
      '/shop/ajio-gold',
      '/shop/ajiomania-sale-shp',
      '/shop/sale',
      '/shop/ajio',
      '/shop/womenswear',
      '/shop/menswear',
      '/shop/kidswear',
      '/shop/men',
      '/shop/women',
      '/shop/kids',
      '/shop/thank-you-page',
      '/shop/azorte',
      '/shop/avantra',
      '/shop/andamen',
      '/shop/stores',
      '/shop/onam-store',
      '/shop/autumn-winter-2022',
      '/shop/pre-buzz',
      '/shop/superstyledays',
      '/shop/scotch-soda',
      '/shop/sneaker-store',
      '/shop/replay',
      '/shop/international-brands',
      '/shop/hunkemoller',
      '/shop/muji',
      '/shop/xint',
      '/shop/buda-jeans-co',
      '/shop/valentinesday-story',
      '/shop/supersonic-page',
      '/shop/brand-toms',
      '/shop/brand-cover-story',
      '/shop/brand-dune-london',
      '/shop/steve-madden',
      '/shop/men',
      '/shop/super-value-store'
    ],

    runtimeBannersUrlListMsite: [
      '/shop/shirts',
      '/shop/t-shirts-for-men',
      '/shop/ajiomania-sale-shp',
      '/shop/sale',
      '/shop/ajio',
      '/shop/early-access',
      '/shop/pre-buzz',
      '/shop/spring-summer',
      '/shop/accessories',
      '/shop/assured-gifts',
      '/shop/saving-calculator',
      '/shop/watches',
      '/shop/womenswear',
      '/shop/menswear',
      '/shop/kidswear',
      '/shop/men',
      '/shop/women',
      '/shop/kids',
      '/shop/international-brands',
      '/shop/footwear',
      '/shop/sports-wear',
      '/shop/mens-innerwear',
      '/shop/womens-lingerie',
      '/shop/mothers-day',
      '/shop/max',
      '/shop/ajio-gold',
      '/shop/superstyledays',
      '/shop/indie',
      '/shop/yoga-wear',
      '/shop/beautystore',
      '/shop/women-western-wear-BSD',
      '/shop/the-spring-summer-edit',
      '/shop/workwear',
      '/shop/sloungewear',
      '/shop/very-pari',
      '/shop/wedding-store',
      '/shop/armani-exchange',
      '/shop/thank-you-page',
      '/shop/g-star-raw',
      '/shop/scotch-soda',
      '/shop/azorte',
      '/shop/homestore',
      '/shop/avantra',
      '/shop/andamen',
      '/shop/raksha-bandhan',
      '/shop/stores',
      '/shop/onam-store',
      '/shop/autumn-winter-2022',
      '/shop/trends-spotter-sep',
      '/shop/search',
      '/shop/festive-page',
      '/shop/durga-puja',
      '/shop/marksandspencer',
      '/shop/spotter',
      '/shop/editdiwali',
      '/shop/jewelers',
      '/shop/sobhita',
      '/shop/hot-pink',
      '/shop/saree',
      '/shop/latest-drop',
      '/shop/the-list',
      '/shop/the-sneaky-trivia',
      '/shop/sneaker-store',
      '/shop/encrustd',
      '/shop/international-brands-page',
      '/shop/aditya-bhalla',
      '/shop/vijay-varma',
      '/shop/xint',
      '/shop/fashion-moments',
      '/shop/replay',
      '/shop/yash-pradhan',
      '/shop/hunkemoller',
      '/shop/muji',
      '/shop/temperature-drop',
      '/shop/buda-jeans-co',
      '/shop/stories-page',
      '/shop/valentinesday-story',
      '/shop/supersonic-page',
      '/shop/brand-toms',
      '/shop/supersonic-event',
      '/shop/brand-ltb',
      '/shop/premium-men',
      '/shop/premium-women',
      '/shop/brand-cover-story',
      '/shop/story-one-palette',
      '/shop/supersonic-event1',
      '/shop/supersonic-event2',
      '/shop/supersonic-event3',
      '/shop/supersonic-event4',
      '/shop/explore-more-brands',
      '/shop/brand-dune-london',
      '/shop/steve-madden',
      '/shop/brand-encrustd-spring-launch',
      '/shop/active-wear-store',
      '/shop/purple-reign-story',
      '/shop/green-acid-story',
      '/shop/men',
      '/shop/super-value-store'
    ],
    runtimeBannersUrlListSis: [],
    runtimeBannersUrlListMsiteSis: [],
    landingPageExpireTime: 15, // in mins
    siteNameToFindIfscCode: 'RBI',
    siteUrlToFindIfscCode: 'https://www.rbi.org.in/Scripts/IFSCMICRDetails.aspx',
    blockNotFoundIfscCodeSubmit: 'OFF',
    showReOpenComplaintFormFlag: 'OFF',
    usps: ['Assured Quality', '100% Handpicked', 'Easy Exchange'],
    uspsPayment: ['Assured Quality', '100% Handpicked', 'Easy Exchange'],
    referralFeatureEnable: 'OFF',
    referrerEnable: 'OFF',
    refereeEnable: 'OFF',
    displayReferralNewTag: 'OFF',
    displayAjioWalletNewTag: 'OFF',
    displayAjioWalletTotalAmount: 'OFF',
    displayNonTransferrableCashLedger: 'ON',
    redirectFindToS1: 'OFF',
    referralShareUtmParams: {
      source: '',
      medium: '',
      campaign: ''
    },
    referralCongratsMessageTimer: 15000,
    referralShareMessage:
      'Your friend _USERNAME_ has invited you to join AJIO. Use invite code _USER_REFERRAL_CODE_ to signup and earn _REFEREE_BONUS_ AJIO Points. You can also use the following link to join:',
    referralWidgetPDPEnable: 'OFF',
    referralWidgetWalletEnable: 'OFF',
    referralWidgetThankYouPageEnable: 'OFF',
    referralWidgetHeading: 'Invite Friends & Earn',
    referralWidgetSubHeading: 'You get ₹_INCENTIVE_ AJIO Points for every friend',
    referralMyAccountLinkTitle: 'Invite Friends',
    referralMyAccountLinkSubTitle: 'Earn ₹_INCENTIVE_ AJIO Points for every friend',
    referralAuthFeedbackTitle: '_USERNAME_ has invited you!',
    referralAuthFeedbackSubTitle: 'Signup to get ₹_INCENTIVE_ AJIO Points',
    referralCongratulationHeading: '_USERNAME_ has given you _INCENTIVE_* AJIO Points',
    referralCongratulationSubHeading: '*expires in _DURATION_VALUE_ _DURATION_UNIT_',
    referralLandingPageHeading: 'Invite Friends & Earn',
    cc_email_response_time_message: 'Response in 24 hours',
    disableGSTContent: '',
    defaultGSTMessage: '',
    ABDistribution: 100,
    returnCapture: {
      isNewOne: 'ON',
      exchangeUnable: 'Exchange is not available for the selected address',
      selfShipMsg:
        'This is a Self Ship request. After placing the request, please send the below product(s) to our address.',
      selfShipCredit: 150
    },
    showCallMeBackForLuxuryOrder: 'OFF',
    showCarrierInfo: 'ON',
    orderFilterFlag: 'ON',
    revampedGoogleAuth: 'OFF',
    carrierInfoTimestamp: 15,
    luxuryOrderFlags: {
      luxuryCallMeBack: 'ON',
      luxuryChatWithUs: 'ON',
      luxuryHLP: 'ON',
      luxuryEmail: 'ON',
      luxury_ccEmailId: 'customercare@ajio.com',
      luxury_ccContactNumber: '1800-889-9991'
    },
    estimatedWaitTimeCMB: 'ON',
    showTimeSlotsCMB: 'ON',
    gameZopCoupons: {
      SJ8X6zyPcyX: [
        {
          coupon: 'Flat 75% Off',
          score: '1000+'
        },
        {
          coupon: 'Flat 55% Off',
          score: '400 - 999'
        },
        {
          coupon: 'Flat 35% Off',
          score: '200 - 399'
        }
      ]
    },
    showScNextQuestionInSecs: 5,
    gamezonetncLink: 'https://www.ajio.com/help/termsAndCondition',
    tncLinkGame: 'https://www.ajio.com/help/termsAndCondition',
    ruleTncLinkGame: 'https://www.ajio.com/scratchcard',
    hurryMsgInvCap: 10,
    timerToRefreshTopShopper: 300000,
    enablePwaInstall: false,
    priceRevealWebFlag: 'OFF',
    luxeFlags: {
      isThemeEnable: 'ON',
      isDesktopThemeEnable: 'ON',
      isFooterEnabled: 'ON',
      footerData: [
        { isEnable: true, title: 'Customer Service', link: '/selfcare' },
        { isEnable: true, title: 'FAQs', link: '/selfcare' },
        { isEnable: false, title: 'Terms & Conditions', link: '/help/termsAndCondition' },
        { isEnable: false, title: 'Returns & Refunds policy', link: '/return-refund-policy' }
      ]
    },
    eGiftCard: 'OFF',
    eGiftCardTnCLink: '/help/termsAndCondition',
    priceRevealLUXEFlag: 'ON',
    shoppingAssistantFlag: 'ON',
    shoppingAssistantData: {
      phoneNumber: ['0804-680-9676', '0804-680-9676'],
      time: '10 AM - 7 PM'
    },
    priceRevealV2MobileFeatureFlag: 'OFF',
    priceRevealMobileData: {
      priceRevealPDPFlag: 'ON',
      priceRevealPLPFlag: 'ON',
      priceRevealWISHLISTFlag: 'ON',
      hashtag: '#BigSale',
      luxeHashtag: '#BigBoldSale',
      bbsDescription: `Your chance to see the Sale price before it starts.`,
      luxeBBSDescription: `Take a sneak peek at the <b style="font: revert;">Big Bold Sale</b> Price before it starts!`,
      bbsTextButton: 'Show Sale Price',
      luxeBbsTextButton: 'Show BBS Price',
      wishlistText: 'Wishlist your favourite products now!',
      luxeWishlistText: 'Update your Wishlist with the hottest picks!',
      bbsPriceStaticText: 'Sale Price',
      luxebbsPriceStaticText: 'BBS Price',
      bbsSaleStartText: 'Sale will be starting soon.',
      bbsSaleEndText: 'Sale will be ending soon.',
      luxeSaleLiveText: 'Big Bold Sale is live!',
      bbsBannerText: 'Buy your favourite products at jaw-dropping discounts.',
      userEduText: 'What is Sale Price?',
      luxeUserEduText: 'What is BBS Price?',
      priceComingSoonTxt: 'Sale Price Coming Soon',
      luxePriceComingSoonTxt: 'BBS Price to be revealed soon',
      hamperImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/img/BBS_Hamper.svg',
        altText: 'Sale giftbox icon'
      },
      priceImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/assets/marketing/Oct-BBS-Star-apps.png',
        altText: 'AJIO sale logo'
      },
      luxePriceImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/assets/marketing/Oct-BBS-Star-apps.png',
        altText: 'AJIO sale logo'
      },
      bannerImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/assets/marketing/Oct-BBS-Logo-apps.png',
        altText: 'AJIO Big Bold Sale logo'
      },
      luxeBannerImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/assets/marketing/Oct-BBS-Logo-apps.png',
        altText: 'AJIO Big Bold Sale logo'
      }
    },
    priceRevealV2WebFeatureFlag: 'OFF',
    priceRevealWebData: {
      priceRevealPDPFlag: 'ON',
      priceRevealPLPFlag: 'ON',
      priceRevealWISHLISTFlag: 'ON',
      hashtag: '#BigSale',
      luxeHashtag: '#BigBoldSale',
      bbsDescription: `Your chance to see the Sale price before it starts.`,
      luxeBBSDescription: `Take a sneak peek at the <b style="font: revert;">Big Bold Sale</b> Price before it starts!`,
      bbsBannerText: 'Buy your favourite products at jaw-dropping discounts.',
      bbsTextButton: 'Show Sale Price',
      luxeBbsTextButton: 'Show BBS Price',
      wishlistText: 'Wishlist your favourite products now!',
      luxeWishlistText: 'Update your Wishlist with the hottest picks!',
      bbsPriceStaticText: 'Sale Price',
      luxebbsPriceStaticText: 'BBS Price',
      bbsSaleStartText: 'Sale will be starting soon.',
      bbsSaleEndText: 'Sale will be ending soon.',
      luxeSaleLiveText: 'Big Bold Sale is live!',
      userEduText: 'What is Sale Price?',
      luxeUserEduText: 'What is BBS Price?',
      priceComingSoonTxt: 'Sale Price Coming Soon',
      luxePriceComingSoonTxt: 'BBS Price to be revealed soon',
      hamperImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/img/BBS_Hamper.svg',
        altText: 'Sale giftbox icon'
      },
      priceImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/assets/marketing/Oct-BBS-Star-apps.png',
        altText: 'AJIO sale logo'
      },
      luxePriceImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/assets/marketing/Oct-BBS-Star-apps.png',
        altText: 'AJIO sale logo'
      },
      bannerImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/img/bbs-image.svg',
        altText: 'AJIO Big Bold Sale logo'
      },
      luxeBannerImgSrc: {
        image: 'https://assets-jiocdn.ajio.com/static/assets/marketing/Oct-BBS-Logo-apps.png',
        altText: 'AJIO Big Bold Sale logo'
      }
    },
    newUserBanner: 'OFF',
    appInstallFeature: {
      homepage: 'ON',
      pdp: 'ON',
      plp: 'ON',
      orderListing: 'ON',
      orderConfirm: 'ON',
      footer: 'ON',
      dynamicAppInstallBanners: 'ON',
      stickyBanner: {
        image: 'Phoneajiologo.svg',
        newUserHeaderText: 'Extra 5% off on your first order',
        newUserSubtexts: [
          '4.3 <span style="color: #FFB800">&#9733;</span> ratings on appstore',
          'buy one get 1 free',
          'free deliveryorders subtext',
          'use coupon ***** get 75% Off'
        ],
        oldUserHeaderText: 'Install app for better experience!',
        oldUserSubtexts: [
          'buy one get 1 free',
          'free delivery orders subtext',
          'use coupon ***** get 75% Off'
        ]
      },
      fixedBanner: {
        image: 'Phoneajiologo.svg',
        downloadImage: 'downloadgreen.svg',
        newUserHeaderText: 'Effortless order tracking',
        newUserSubtexts: [
          '4.3 <span style="color: #FFB800">&#9733;</span> ratings on appstore',
          'buy one get 1 free',
          'free delivery  orders subtext',
          'use coupon ***** get 75% Off'
        ],
        oldUserHeaderText: 'Effortless order tracking',
        oldUserSubtexts: [
          'buy one get 1 free',
          'free delivery orders subtext',
          'use coupon ***** get 75% Off'
        ]
      },
      footerBanner: {
        andoridImage: 'Google_Play_footer.svg',
        iosImage: 'App_Store_Footer.svg',
        text: 'Experience the AJIO mobile app'
      },
      offerBanner: {
        text: 'Save more with App exclusive offers'
      },
      carouselBanner: [
        {
          bannerImage:
            'https://assets-jiocdn.ajio.com/cms/LUXE/MOBILE/20062024-M-Luxe-Induslnd%20Strip%20.jpg',
          isAppInstallBanner: true,
          redirectionUrl: ''
        },
        {
          bannerImage:
            'https://assets-jiocdn.ajio.com/cms/LUXE/MOBILE/20062024-M-Luxe-Induslnd%20Strip%20.jpg',
          isAppInstallBanner: false,
          redirectionUrl: 'https://qa.services.ajio.com/c/83'
        },
        {
          bannerImage:
            'https://assets-jiocdn.ajio.com/cms/LUXE/MOBILE/20062024-M-Luxe-Induslnd%20Strip%20.jpg',
          isAppInstallBanner: false,
          redirectionUrl: 'https://qa.services.ajio.com/my-account/'
        }
      ]
    },
    appConfig: {
      androidPackageName: 'com.ril.ajio',
      androidSubDomain: 'ajiofnl',
      iosPackageName: 'com.ril.ajio',
      iosSubDomain: 'ajiofnl',
      iosUrlScheme: 'ajioapps',
      iosStoreId: '1113425372'
    },
    topShopperHeader: 'Chance to win',
    topShopperSubHeader: 'Rewards worth 70 Lakhs',
    eventHowToParticipateContentList: [
      'Top Shopper contest is live for users during the Big Bold Sale',
      'All users placing orders during the contest duration will be considered for the participation',
      'Each day is divided into 8 slots of 3 hours each & for each slot, the top shopper(based on net order value) will be considered as the winner',
      'If user places multiple orders during same slot, those order values will be added & total order value is considered',
      'If two users placed order for same amount, the user who placed order earlier will be considered as the winner',
      'Please note that the net order value will be considered for each user after reducing the amount for any cancellations/returns',
      'Refer to the complete terms & conditions list for this contest using the link given below'
    ],
    topHeaderPrize: 'Grand Prize',
    luckyDrawText: 'Lucky draw list',
    luckyChampList: 'The List of lucky champs',
    topShopperHowToWinList: [
      'Winners from daily sale events are eligible to the lucky draw for grand prize.',
      'Lucky draw list will be automatically updated as soon as a sale event is over.',
      'At the end of the Big Bold Sale the draw will happen.',
      'The winners will be contacted by our executives for further procedures & reward distribution.'
    ],
    showConsentFormForCards: 'OFF',
    similarPopupTimeOut: 2,
    isNewBrandDirectoryMsite: 'ON',
    isNewBrandDirectoryDesktop: 'ON',
    earlyAccessVariant: '22.08.02',
    earlyAccessEnabled: 'OFF',
    earlyAccessBannerCategory: 'OFF',
    earlyAccessData: {
      earlyAccessText: `Early Access for All Products is live!`,
      BBSText: 'Buy at BBS Price till',
      earlyAccessSaleStartText: 'Hurry, last chance before the sale starts',
      priceImgSrc: {
        image: 'https://assets-uat.ajio.ril.com/static/img/luxe-pr-default-mobile-price.svg',
        altText: 'AJIO Sale logo'
      },
      bannerImgSrc: {
        image: 'https://assets-uat.ajio.ril.com/static/img/early_access.png',
        altText: 'AJIO Big Bold Sale logo'
      },
      earlyAccessHashtag: '#BBSEarlyAccess',
      BBSPriceText: 'BBS Price'
    },
    enableClusterFeature: 'ON',
    enableClusterFeatureHome: 'ON',
    enableClusterFeaturePDP: 'OFF',
    enableDeviceIdPersonalization: 'ON',
    isSimilarPopupDisplay: 'ON',
    jioEngageHistory: 'OFF',
    enableWriteToLog: 'OFF',
    topShopperGrand: 'OFF',
    assuredGifts: 'ON',
    assuredGiftsFlag: {
      pdpAssuredGifts: 'ON',
      cartAssuredGifts: 'ON',
      shippingAssuredGifts: 'ON',
      paymentAssuredGifts: 'ON',
      orderConfirmationGifts: 'ON'
    },
    assuredGiftsLandingData: {
      giftMileStone: {
        header: 'Gift Milestones',
        subHeader: 'Take a look at what gifts you can win based on your Order Amount'
      },
      howItWorks: {
        header: 'How It Works',
        subHeader:
          'A step-by-step approach on how you can redeem your gifts and enjoy all benefits!',
        steps: [
          'You will receive a voucher code via e-mail for all products after you have placed your order',
          'Use the voucher code upon checkout in the next order to receive the products.',
          'In case of third-party voucher codes, instructions will be provided to you over email on how to redeem',
          'These are for one-time use only. Also, these codes cannot be used for other related brands'
        ]
      },
      ourPartners: {
        header: 'Our Partners',
        subHeader:
          'Check out the popular brands and outlets providing jaw-dropping discounts and memberships',
        partnerArr: ['https://assets-jiocdn.ajio.com/static/img/assuredPartner.png']
      },
      minOrderValue: 1000,
      tncLink: '/help/termsAndCondition',
      giftsWorth: 'You’re Getting Free Gifts worth ₹',
      getFreeGifts: 'Get Free Gifts with this order',
      assuredGiftsHeadrText:
        'You’re just a step away! Shop for the required order amounts below and get free gifts with this order',
      giftBoxText: 'Free Gifts with this Order',
      howToRedeemText: 'Check out how to redeem your Free Gifts',
      knowMore: 'Know More',
      freeGiftHead: 'Woohoo! You are getting these gifts',
      worth: 'worth ₹',
      rangeText: 'For Order Amount between ₹',
      aboveRangeText: 'For Order Amount Above ₹',
      rupee: '₹',
      free: 'FREE',
      atleastText: 'Shop for at least',
      atleastSecondText: 'to win gifts in this level',
      viewGifts: 'View Gifts',
      orderAmount: 'Order Amount: ₹',
      shopAndWin: 'Shop & Win Free Gifts with your order',
      meetRequiredCriteria: 'Meet the required order amount & win exciting gifts',
      shopAndWinWithNextOrder: 'Shop & Win Free Gifts with your Next order',
      gauranteedGifts: 'Shop for a minimum required amount and get guaranteed gifts',
      gifts: 'Gifts List',
      detailsSent: 'Details sent to your Email/SMS and My Rewards Page.',
      viewRewards: 'View Rewards',
      detailsSentPayment:
        'Details will be sent to your Email/SMS and My Rewards Page on how to redeem these gifts.',
      winExcitingGifts: 'Win Exciting Free Gifts based on your Order Amount'
    },
    enable_cancellation_request: 'ON',
    enableJioAdsSdk: 'ON',
    enableAdsOnPlp: 'OFF',
    enableAdsOnSlp: 'OFF',
    bankOfferPDPAggregator: 'OFF',
    bankOfferHybris: 'OFF',
    sizeRecommendationPrimeAILinkFlag: false,
    codConvenienceData: {
      showCodConvenienceFeeFlow: 'ON',
      showRefundPolicy: 'ON',
      showCodConvenienceFee: 'ON',
      showRVPConvenienceFee: 'ON',
      convenienceFeeNote:
        '<b>Note: </b>Convenience fee is not refundable in case you choose to return the order.',
      convenienceRefundPolicy: {
        readPolicyUrl: 'https://www.ajio.com/return-refund-policy',
        imageUrl: {
          image: 'https://assets-jiocdn.ajio.com/static/img/policyCod.png',
          altText: 'Cards icon'
        },
        policyTitle: 'Cancellation, return & refund policies',
        policyData: [
          {
            description: 'In case of return or refund convenience charges will not be refunded'
          },
          {
            description:
              'Convenience fee which includes delivery fee & shopping convenience charges are non refundable.'
          }
        ]
      },
      convenienceFeeInfo: {
        'COD Convenience Fee': {
          title: 'Cash on Delivery Fee',
          description:
            'This fee is charged to provide you with the convenience of paying for orders at your doorstep'
        },
        'Delivery Fee': {
          title: 'Delivery Fee',
          description:
            'We charge a delivery fee on orders below ₹${amount} to cover our shipping costs'
        },
        'Platform Convenience Fee': {
          title: 'Platform Convenience Fee',
          description:
            'This fee is charged to ensure a hassle-free shopping and delivery experience for you. It is used to maintain a strong delivery network and stock availability.  '
        },
        'Priority Delivery Fee': {
          title: 'Priority Delivery Fee',
          description: 'Charged to deliver your product on Priority'
        },
        'Rush Delivery Fee': {
          title: 'Rush Delivery Fee',
          description: 'Charged to deliver your product on Priority'
        }
      },
      showConvenienceFeeWhatThis: 'ON'
    },
    displayAjioWallet: 'ON',
    classifier: 'intent',
    cancelationRequestOldFlag: 'OFF',
    isUaas: 'ON',
    brandCompare: 'OFF',
    enabledDeleteForNotifyMe: 'OFF',
    notifyMessageConfig: {
      alreadyNotifyMsg: 'We have already received your interest. Stay tuned!',
      initialNotifyMsg: 'Thank you! We will update you once this is launched'
    },
    enableBrandSizeToggleBtn: 'OFF',
    allOffers: 'OFF',
    freeShippingAmountLimit: 1199,
    enabledFreeDeliveryPdpTag: 'OFF',
    enabledProductImageInColourPallet: 'OFF',
    brandSizeToggleText: 'Show sizing used by ${brandName}',
    version: 'latest{task}',
    productCountWishlistWidgetSearchScreen: 5,
    AjioFraudReductionForEmployeeCoupons: {
      ctaLabels: {
        verifyEmail:
          "To use employee benefits, we'll need you to verify your email ID from time to time",
        verifyRilEmpTxt:
          'Hey Reliance employee! You can avail employee benefits by <span>verifying your official email ID from Account page</span>',
        updateRilEmpTxt:
          'Hey Reliance employee! Once you create your account, you have to <span>verify your official email ID to use employee benefits.</span>you can do that in Account page',
        tooltipTxt:
          'To ensure that you are a Reliance employee, we verify your official Email ID via OTP from time to time'
      },
      fraudReductionForEmployeeCoupons: 'OFF',
      couponApplicableCart: 'OFF',
      availableDomains: [
        'ril.com',
        'zmail.ril.com',
        'nw18.com',
        'viacom18.com',
        'colosceum.com',
        'indiacast.com',
        'reliancefoundation.org',
        'visionexpress.in',
        'gofynd.com',
        'netmeds.com',
        'csquare.in',
        'urbanladder.com ',
        'ajio.com',
        'qalara.com',
        'jiobp.com'
      ]
    },
    comprehensive_brickcode_list: {
      brickCode: [
        '830207010',
        '830611006',
        '830705006',
        '830508006',
        '830307015',
        '830216001',
        '830113001',
        '830710006',
        '830316001',
        '830317003',
        '830401009',
        '830501006',
        '830601009',
        '830216013',
        'all'
      ]
    },
    dataNotFoundText: "Oops! We couldn't find any Similar Styles",
    showSimilarProductsPlp: true,
    internalWalletsOnCart: 'OFF',
    enableRedemptionOptionsOnCart: true,
    newOfferBenefitsConfig: {
      totalSavingStripThreshold: 1,
      ajioPointsThreshold: 1
    },
    showHomeRating: 'OFF',
    showPDPRateSection: 'OFF',
    showRateProdBtn: 'OFF',
    enableRating: 'OFF',
    enableAjiogramRating: 'ON',
    enableReview: 'OFF',
    showReviewProdBtn: 'OFF',
    subRatingFlag: [
      {
        question: 'How was the product Quality?',
        answer: 'Product Quality'
      },
      {
        question: 'How is the value for money?',
        answer: 'Value for Money'
      }
    ],
    isMergeCheckStockInFetchCart: 'OFF',
    showSimilarProductsPlp: 'ON',
    showViewType: 1,
    howToMeasureVisibleInSizeGuideFlag: 'OFF',
    enabledKnowTheProductFlag: 'OFF',
    olRatingFlag: 'OFF',
    odRatingFlag: 'OFF',
    bannerLoginPageFlag: 'ON',
    bannerLoginPage: {
      '1': {
        image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/CTA_500_AJIO_122022_Mobile.png',
        altText: 'Sign up and get 500 AJIO Points'
      },
      '2': {
        image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/CTA_500_AJIO_122022_Mobile.png',
        altText: 'Sign up and get 500 AJIO Points'
      },
      '3': {
        image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/CTA_500_AJIO_122022_Mobile.png',
        altText: 'Sign up and get 500 AJIO Points'
      }
    },
    bannerSignupPageFlag: 'ON',
    bannerSignupPage: {
      '1': {
        image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Varient_1B.jpg',
        altText: 'Sign up and get 500 AJIO Points'
      },
      '2': {
        image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Varient_2B.jpg',
        altText: 'Get extra 30% off on first order. Use coupon named FIRSTBUY'
      },
      '3': {
        image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Varient_3B.jpg',
        altText: 'Sign up and get free shipping on first order'
      }
    },
    publicKey:
      '30819F300D06092A864886F70D010101050003818D0030818902818100D4B505858D2E99BC2E0CA26847EF353D4644E7EE7F364D904F8A2E1ACAA38C981AAEB3F525B4BA230026824429BE7C52901AA3EE8500D8A45E835CDFBE8918AE3B68B0D2588EA5F649B37FA528A7FCC645121AB418FD22690D7DFF9482242C5CC010D2535B7A964EE4A43953CC19C56345E2D00A752D7069DA6724CF850968B30203010001',
    versionForEncryption: 'VERSION_1',
    enable_return_bank_info_encryption: 'ON',
    enable_save_imps_bank_encryption: 'OFF',
    knowTheProduct_brickcode_list: {
      brickCode: [
        '830207010',
        '830611006',
        '830705006',
        '830508006',
        '830307015',
        '830216001',
        '830113001',
        '830710006',
        '830316001',
        '830317003',
        '830401009',
        '830501006',
        '830601009',
        '830216013',
        'all'
      ]
    },
    isMyJioIntegrationUaas: 'ON',
    showRateCalculate: 'OFF',
    rateCalculateText:
      "Ratings are calculated based on several factors such as its recency, trust worthiness, purchase verification etc. It's not a simple average.",
    loginToApplyCouponCTA: 'Login to select coupon',
    loggedInApplyCouponToast: 'Welcome to AJIO 🎉 Save every time you shop',
    howToMeasureSizeGuide: {
      howToMeasureNewImagesFlag: 'ON',
      howToMeasureProducts: [
        {
          brickCategory: 'Men',
          brickName: 'Jeans',
          brickSubCategory: 'Western Wear'
        },
        {
          brickCategory: 'Men',
          brickName: 'Trousers & Pants',
          brickSubCategory: 'Western Wear'
        },
        {
          brickCategory: 'Men',
          brickName: 'Sweatshirts & Hoodie',
          brickSubCategory: 'Western Wear'
        },
        {
          brickCategory: 'Men',
          brickName: 'Shirts',
          brickSubCategory: 'Western Wear'
        },
        {
          brickCategory: 'Men',
          brickName: 'Tshirts',
          brickSubCategory: 'Western Wear'
        },
        {
          brickCategory: 'Men',
          brickName: 'Jackets & Coats',
          brickSubCategory: 'Western Wear'
        },
        {
          brickCategory: 'Women',
          brickName: 'Kurta Suit Sets',
          brickSubCategory: 'Ethnic Wear'
        },
        {
          brickCategory: 'Women',
          brickName: 'Kurtas',
          brickSubCategory: 'Ethnic Wear'
        },
        {
          brickCategory: 'Women',
          brickName: 'Jeans & Jeggings',
          brickSubCategory: 'Western Wear'
        },
        {
          brickCategory: 'Women',
          brickName: 'Sweatshirts &Hoodies',
          brickSubCategory: 'Western Wear'
        },
        {
          brickCategory: 'Men',
          brickName: '',
          brickSubCategory: 'Footwear'
        },
        {
          brickCategory: 'Women',
          brickName: '',
          brickSubCategory: 'Footwear'
        }
      ]
    },
    displayMyRewardsNewTag: 'ON',
    displayJioPrimePointsNewTag: 'ON',
    bagChangesInterval: 2000,
    luxeBrandsPageWithImages: 'ON',
    setLuxeBrandsAlternateUrl: 'OFF',
    unlockedText: 'Yay 🎉 You’ve unlocked ${offerCount} more offers',
    floatingWidgetFlags: {
      widgetMaxApperanceCount: 2,
      autoDismissDuration: 15,
      enableAutoDismiss: false
    },
    // flags for JIO Banner Ads
    jioAdStartPositionMSite: 7,
    jioAdsEndPositionMsite: 103,
    jioAdsFrequencyMsite: 6,
    // jioAds positioning for desktop
    jioAdsStartRowDesktop: 3,
    jioAdsEndRowDesktop: 35,
    jioAdsRowCount: 2,
    showAdTagBannerListingAds: false,
    // facets calculations
    facetType: 'l1l3nestedcategory',
    facetOperatorType: 'greater',
    facetPercentage: 5,
    // plp and slp flag to toogle to feature
    enableBannerAdsOnPlp: 'ON',
    enableBannerAdsOnSlp: 'ON',
    wishlistUnratedProductsWidgetPosition: 4,
    plpUnratedProductsWigetPosition: 6,
    businessCancellationMessage:
      'Your order had to be canceled due to logistics restrictions.\nTo make up for this, you will receive a special coupon code via SMS within 24 hrs as a token of apology, which you can use on your future purchase on AJIO.',
    displayRatingLabelPLP: 'OFF',
    displayRatingLabelWishlist: 'OFF',
    displayRatingLabelCart: 'OFF',
    tncListData: [
      'Top Shopper contest will be live during the duration of Big Bold Sale',
      'The contest is only open to users who have successfully placed an order on AJIO - either through prepaid (or) through cash on delivery (COD) mode',
      'AJIO shall not charge any amount from any user for taking part in this contest',
      "The rewards mentioned as the prize for each slot can change based on any external factors out of AJIO's control",
      'If user places multiple orders during same slot, those order values will be added & total order value is considered',
      'If two users placed order for same amount, the user who placed order earlier will be considered as the winner',
      'Please note that the net order value will be considered for each user after reducing the amount for any cancellations/returns',
      'A user whose name appears on top of leaderboard does not guarantee reward. The final winners will be chosen by AJIO after considering cancellations & returns'
    ],
    streetFlags: {
      isThemeEnableMsite: 'OFF',
      isThemeEnableWeb: 'OFF',
      isEmailOptionalMsite: 'OFF',
      isEmailOptionalWeb: 'OFF'
    },
    similarProductsPDP: {
      stores: {
        isAjio: 'ON',
        isLuxe: 'ON',
        isStreet: 'ON',
        others: 'ON'
      }
    },
    similarProductsPLP: {
      stores: {
        isAjio: 'ON',
        isLuxe: 'ON',
        isStreet: 'ON',
        others: 'ON'
      }
    },
    similarProductsMaxLimit: 10,
    showRecentSearchItemsLimit: 10,
    storesForHidingMRP: ['ajioStreet'],
    bagTotalNotAvailableForOrders: true,
    exchangeRTOScreenUpdate: 'ON',
    privacyPolicyUrl: 'https://www.ajio.com/privacypolicy',
    searchExpFlags: [
      { searchExp1: 'true' },
      { searchExp2: 'true' },
      { searchExp3: 'true' },
      { searchExp4: 'true' },
      { searchExp5: 'true' }
    ],
    fileSizeForCompression: 1572864,
    showUserConsent: 'OFF',
    master_GA3: 'OFF',
    master_GA4: 'OFF',
    release1_GA4: 'OFF',
    showClosedtoOpenBox: 'OFF',
    tradeDiscountValueExp: 'ON',
    tradeDiscountPercentageMax: 30,
    tradeDiscountValueMin: 1000,
    enableProductCodeTag: 'ON',
    landingPagesExperiments: ['CMSABExp2', 'CMSABExp1', 'CMSABExp3', 'CMSABExp4', 'CMSABExp5'],
    jioAdsLandingPagesExperiment: 'CMSABExp2',
    jioAdsLandingBannersFlag: 'ON',
    jioAdsSpecs: {
      adSpotId: '239x4lqb',
      userGroup: 'non_premium',
      userRestriction: 'new',
      bufferTimeForPreview: 10,
      apiTimeoutLimit: 700,
      sdkParams: {
        ifa: 'fba4bd45-4814-495d-ba62-63f88a37be7f',
        os: '4',
        vr: 'web-2.0.10'
      },
      defaultExperiment: 'OFF'
    },
    enableDeliveryFeeTag: 'ON',
    storeWiseDeliveryFeeTags: {
      street: {
        title: 'Free Delivery',
        flag: 'ON'
      },
      ajiofreedelivery: {
        title: 'Free Delivery',
        flag: 'ON'
      },
      ajiodeliveryfee: {
        title: 'Delivery Fee Applicable',
        flag: 'ON'
      },
      luxefreedelivery: {
        title: 'Free Delivery',
        flag: 'ON'
      },
      luxedeliveryfee: {
        title: 'Delivery Fee Applicable',
        flag: 'ON'
      }
    },
    keepAliveTimeout: 6000, // time in milliseconds
    masterFlagFleek: 'ON',
    fleekFeedPaginationSize: 10,
    onboardingImages: [
      'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/OnboardiSDng_1SDSDDS.png',
      'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Onboarding_2ASDDS.png'
    ],
    onBoardingBackgroundImage: {
      image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/BackgroundASDSD.png',
      altText: 'Background'
    },
    onBoardingFleekAutoScroll: 'ON',
    showConvertedGifs: 'OFF',
    onBoardingAutoScrollDuration: 3000,
    showFleekSplashScreen: 'ON',
    showFleekOnboardingScreens: 'OFF',
    fleekMiniPLPProductCount: 8,
    fleekAudioIsUnMuted: 'ON',
    showRevampedNavigation: 'ON',
    showInterstitial: 'ON',
    showCoachMark: 'ON',
    interstitialMilestonePeriod: {
      appLaunch: 1,
      firstMilestone: 30,
      secondMilestone: 30,
      thirdMilestone: 30,
      forthMilestone: 30
    },
    searchBarAnimationCounter: 2,
    navigationConfigs: {
      coachMarkTimer: 3000,
      ajio: {
        image: {
          image: 'https://assets-uat.ajio.ril.com/static/img/ajio-splash-screen-icon.svg',
          altText: 'AJIO logo'
        },
        backgroundColor: '#2F4254',
        loadingText: 'Get ready for hottest styles',
        loadingGif: {
          image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/loading_AJIO%20regular.gif',
          altText: 'Loading'
        },
        coachMarkText: 'You are now on AJIO store',
        coachMarkSubtext: 'Click on switch stores to explore other options',
        errorText: "Oops! We're facing an issue with our services",
        errorSubText: 'Check your connection and try refreshing the page',
        categoryPageErrorText: "Oops! We're facing an issue with our services",
        categoryPageErrorSubText: 'Check your connection and try refreshing the page'
      },
      luxe: {
        image: {
          image:
            'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Ajio%20Luxe%20splash%20screen%20logo.png',
          altText: 'AJIO LUXE logo'
        },
        backgroundColor: '#121212',
        loadingText: 'Loading luxury fashion',
        loadingGif: {
          image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/loading_LUXE.gif',
          altText: 'Loading'
        },
        coachMarkText: 'You are now on LUXE store',
        coachMarkSubtext: 'Click on switch stores to explore other options',
        errorText: 'Oh no! There seems to be a hiccup in our service',
        errorSubText: 'Check your connection and try refreshing the page',
        categoryPageErrorText: 'Oh no! There seems to be a hiccup in our service',
        categoryPageErrorSubText: 'Check your connection and try refreshing the page'
      },
      street: {
        image: {
          image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Street%20splashscreen%20logo.png',
          altText: 'AJIO Street logo'
        },
        backgroundColor: '#B9E0DB',
        loadingText: 'Getting your best deals',
        loadingGif: {
          image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/loading_Street.gif',
          altText: 'Loading'
        },
        coachMarkText: 'You are now on STREET store',
        coachMarkSubtext: 'Click on switch stores to explore other options',
        errorText: "Oops! We're facing an issue with our services",
        errorSubText: 'Check your connection and try refreshing the page',
        categoryPageErrorText: "Oops! We're facing an issue with our services",
        categoryPageErrorSubText: 'Check your connection and try refreshing the page'
      },
      ajiogram: {
        stortIcon: {
          image: 'https://assets-jiocdn.ajio.com/cms/AJIO/WEB/Story_animate.gif',
          altText: 'story icon'
        },
        image: {
          image: 'https://assets-uat.ajio.ril.com/static/img/street-splash-screen-icon.svg',
          altText: 'Ajiogram Logo'
        },
        backgroundColor: '#B9E0DB',
        loadingText: 'Dope styles incoming...',
        loadingGif: {
          image: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Splashscreen_Loader.gif',
          altText: 'Loading'
        },
        coachMarkText: 'You are now on AJIOGRAM store',
        coachMarkSubtext: 'Click on switch stores to explore other options',
        errorText: "Oops! We're facing an issue with our services",
        errorSubText: 'Check your connection and try refreshing the page',
        categoryPageErrorText: "Oops! We're facing an issue with our services",
        categoryPageErrorSubText: 'Check your connection and try refreshing the page',
        splashScreenGif: {
          image: 'https://assets-jiocdn.ajio.com/cms/LUXE/WEB/splash-screenASD.gif',
          altText: 'Ajiogram loading'
        },
        splashScreenStaticImage: {
          image: 'https://assets-jiocdn.ajio.com/cms/LUXE/WEB/MicrosoftTeams-imageasdfasdfas0).png',
          altText: 'Ajiogram background'
        }
      }
    },
    childStores: ['trends', 'muji', 'azorte', 'gap', 'avantra'],
    removal_login_password_json: {
      restore_web_url: 'https://www.ajio.com/login?referrer=/my-account/',
      enable_restore_phone_number: true,
      login_restore_phone_number_message:
        'Email based login is no longer available. Please click here to restore your mobile number.',
      signup_restore_phone_number_message:
        'Email address is already linked to another account. Use a different email address or restore phone number.',
      myaccount_request_phone_update_message:
        'Your request for phone number update is in progress. It will update in next %s.',
      profile_change_new_number_note:
        "The new phone number will be updated within %s. It won't affect any pending orders, new orders, or fund transfers. You can still use the current phone number until the update is complete.",
      verification_email_text: 'Verification Email Sent',
      verification_email_text_description:
        'An email with a link to restore your mobile number has been sent to your registered email. Please use the link to update or confirm your mobile number.',
      updation_time: '24'
    },
    removal_login_password_json: {
      restore_web_url: 'https://www.ajio.com/login?referrer=/my-account/',
      enable_restore_phone_number: true,
      login_restore_phone_number_message:
        'Email based login is no longer available. Please click here to restore your mobile number.',
      signup_restore_phone_number_message:
        'Email address is already linked to another account. Use a different email address or restore phone number.',
      myaccount_request_phone_update_message:
        'Your request for phone number update is in progress. It will update in next %s hours.',
      profile_change_new_number_note:
        "The new phone number will be updated within %s hours. It won't affect any pending orders, new orders, or fund transfers. You can still use the current phone number until the update is complete.",
      verification_email_text: 'Verification Email Sent',
      verification_email_text_description:
        'An email with a link to restore your mobile number has been sent to your registered email. Please use the link to update or confirm your mobile number.',
      updation_time: '24'
    },
    accountCheckApiErrorMsgForSignup: 'Email ID is already registered with us',
    affiseAfSecure: '4626f2b39340d85d337aeaa2c826e241',
    ajiogramDesktopRedirectBanner: {
      image: 'https://assets-jiocdn.ajio.com/cms/AJIO/WEB/MicrosoftTeams-imageasdasdasd.png',
      altText: 'Ajiogram only available on app'
    },
    enableLinkCohort: 'ON',
    resetLinkCohort: 'OFF',
    enableAffiseAffiliation: true,
    storiesPaginationSize: 5,
    ajiogram_pdp_ui_configuration: {
      HEADER_MODEL: 1,
      PRODUCT_SCROLLER: 2,
      PRODUCT_INFO_MODEL: 3,
      COLOR_MODEL: 4,
      SIZE_MODEL: 5,
      EDD_MODEL: 6,
      RETURN_MODEL: 7,
      OFFER_MODEL: 8,
      BANK_OFFERS: 9,
      PDP_DETAILS: 10,
      PDP_KNOW_THE_PRODUCT: 11,
      STYLING_IDEA: 12,
      RATING_AND_REVIEW_MODEL: 13,
      BRAND_DESC_MODEL: 14,
      PDP_ACTIONS: 15,
      REFERRAL_MODEL: 16,
      CROSS_SELL: 18,
      SIMILAR_MODEL_PRODUCT: 18,
      PDP_MORE_INFORMATION: 20,
      RV_MODEL: 19,
      FOOTER_MODEL: 21,
      ASSURED_QUALITY: 22,
      EXTERNAL_ADS_MODEL: 17,
      QUICK_LINKS: 17,
      TREND_VIBE_WIDGET: 5
    },
    ajio_pdp_ui_configuration: {
      HEADER_MODEL: 1,
      PRODUCT_SCROLLER: 2,
      PRODUCT_INFO_MODEL: 3,
      ASSURED_QUALITY: 4,
      OFFER_MODEL: 5,
      METAL_PURITY: 6,
      PRICE_REVEAL: 7,
      SIZE_MODEL: 7,
      PRICE_BREAKUP_MODEL: 7,
      EDD_MODEL: 8,
      BANK_OFFERS: 9,
      COLOR_MODEL: 10,
      PDP_DETAILS: 11,
      TRUST_MARKER: 12,
      RATING_AND_REVIEW_MODEL: 13,
      RETURN_MODEL: 14,
      PDP_ACTIONS: 15,
      REFERRAL_MODEL: 16,
      CROSS_SELL: 18,
      SIMILAR_MODEL_PRODUCT: 24,
      RV_MODEL: 20,
      FOOTER_MODEL: 25,
      PDP_MORE_INFORMATION: 22,
      PDP_KNOW_THE_PRODUCT: 23,
      YOU_MAY_ALSO_LIKE_MODEL: 24,
      PDP_INTERVENTIONS: 14,
      EXTERNAL_ADS_MODEL: 17,
      QUICK_LINKS: 17,
      TREND_VIBE_WIDGET: 5
    },
    luxe_pdp_ui_configuration: {
      HEADER_MODEL: 1,
      PRODUCT_SCROLLER: 2,
      PRODUCT_INFO_MODEL: 3,
      EDD_MODEL: 5,
      BANK_OFFERS: 6,
      OFFER_MODEL: 7,
      PDP_DETAILS: 8,
      RATING_AND_REVIEW_MODEL: 9,
      SHOPPING_ASSISTANT_MODEL: 10,
      RETURN_MODEL: 11,
      PDP_ACTIONS: 12,
      RV_MODEL: 13,
      CROSS_SELL: 13,
      SIMILAR_MODEL_PRODUCT: 14,
      FOOTER_MODEL: 17,
      PDP_MORE_INFORMATION: 16,
      PDP_KNOW_THE_PRODUCT: 18,
      YOU_MAY_ALSO_LIKE_MODEL: 19,
      EXTERNAL_ADS_MODEL: 15,
      QUICK_LINKS: 15,
      TREND_VIBE_WIDGET: 5
    },
    fleekVideoControlConfig: {
      post: {
        loop: true,
        autoPlay: true,
        isMuteOnMinimized: true,
        isMuteOnFullScreen: true
      },
      blp: {
        topBanner: {
          loop: true,
          autoPlay: true,
          isMuteOnMinimized: true
        }
      },
      feed: {
        post: {
          loop: true,
          autoPlay: true,
          isMuteOnMinimized: true,
          isMuteOnFullScreen: true
        },
        stories: {
          isMuteOnFullScreen: true
        }
      },
      exploreBrands: {
        banner: {
          loop: true,
          autoPlay: true,
          isMuteOnMinimized: true
        },
        brand: {
          loop: false,
          autoPlay: true,
          isMuteOnMinimized: true
        }
      },
      brandPage: {
        topBanner: {
          loop: true,
          autoPlay: true,
          isMuteOnMinimized: true
        },
        middleBanner: {
          loop: true,
          autoPlay: true,
          isMuteOnMinimized: true
        },
        carousel: {
          loop: true,
          autoPlay: true,
          isMuteOnMinimized: true
        },
        post: {
          loop: true,
          autoPlay: true,
          isMuteOnMinimized: true,
          isMuteOnFullScreen: true
        },
        stories: {
          isMuteOnFullScreen: true
        }
      },
      pdp: {
        brandBanner: {
          loop: true,
          autoPlay: true,
          isMuteOnMinimized: true
        },
        styleCarousel: {
          isMuteOnMinimized: true
        }
      }
    },
    landingPageFloatingWidget: 'ON',
    optimizeExperiments: {
      ajio: {
        jioBannerAds: '0',
        productWidget: '0',
        videoBanners: '0',
        enable_urgency_driver_pdp: '0',
        'version-flag': '0',
        'desktop-chatbot': '0',
        'assured-gifts': '0',
        plpExtendedBanner: '0',
        CMSABExp5: '0',
        homeRatingWidget: '0',
        singlePageCheckout: '0'
      },
      luxe: {
        jioBannerAds: '0',
        homeRatingWidget: '0',
        CMSABExp5: '0'
      }
    },
    enableCustomerTypeApiUAAS: 'OFF',
    enableMyAccountLinksCMS: 'OFF',
    enablePreOrderOnbording3pVendors: 'OFF',
    onboarding3PVendorsText: 'Wallet is not applicable due to following products',
    enableReturnProcessingFee: 'OFF',
    returnProcessingFeeCartPageText: 'Return Fee of %s chargeable per product if returned.',
    blockedForCancellationDesktop: 'OFF',
    blockedForCancellationMsite: 'OFF',
    removeAjioWalletRefundDesktop: 'OFF',
    removeAjioWalletRefundMsite: 'OFF',
    removeAjioWalletRefundTexts: {
      removeAjioWalletReturnText: 'Enter your Bank details to initiate refund.',
      removeAjioWalletReturnTextForSelfShip: 'Kindly Enter your Bank details to initiate refund.',
      orderListingBankDetailsRequired: 'Kindly enter your bank details inside.'
    },
    retireRCSWallet: 'OFF',
    retireRCSWalletLedger: 'OFF',
    retireRCSWalletText: {
      storeCredit_text1: 'Refunds will be credited within 2-4 hours.',
      storeCredit_text2: 'This refund, once added, will never expire.',
      storeCredit_text3: 'Amount in Wallet is Non-Transferable to bank.',
      bankTransfer_text1: 'Refunds will be credited within 2-4 hours.'
    },
    ga4_ajio_enable: 'OFF',
    enableChatWithUsODP: 'OFF',
    returnCodCommunication: {
      isCartEnabled: true,
      isPdpEnabled: true,
      messageReturn: '%x day Return',
      messageReturnAndExchange: '%x day Return and Exchange',
      messageNoReturnAndExchange: 'No Return and Exchange',
      messageExchange: '%x day Exchange',
      pdpTitle: 'Delivery & Return Details',
      returnPolicyTitle: 'Return Policies',
      codAvailableMsg: 'Cash on Delivery Available',
      codUnavailableMsg: 'Cash on Delivery unavailable, online payment mode only',
      messageReturnDesktop: '%x day Return',
      messageReturnAndExchangeDesktop: '%x day Return and Exchange',
      messageNoReturnAndExchangeDesktop: 'No Return and Exchange',
      messageExchangeDesktop: '%x day Exchange',
      messageNonReturnableDesktop: 'Non Returnable',
      messageNoExchangeDesktop: 'No Exchange',
      codAvailableMsgDesktop: 'Cash on Delivery Available',
      codUnavailableMsgDesktop: 'Cash on Delivery unavailable, online payment mode only'
    },
    enable_pancard_collection: {
      isPanEnabled: true,
      keyVersion: 'VERSION_1',
      encryptionKey:
        '30819F300D06092A864886F70D010101050003818D0030818902818100ABE0E1F504F61CF2BD7A64B395CA86565B5DB9ABB0F39C44BE7F7082284ABC8DD31D5680F9A289BD851F0C3656F214998A4BFEEE86318BCE77BC01FE9F496257E7B167B303AE0D4F178D6EE044DD7636D1E24DEEB82453349A5BA1962C0F41C7C73A965EF64691EEA6D5CFE97C442A92F3947A059ED89470D7C8B7492C7D7CB90203010001'
    },
    colorSwatchBrickCode: {
      brickCodes: ['830312004']
    },
    pdpToBagConversionMasterFlag: 'OFF',
    pdpToBagConversionConfig: {
      pdpToBagOOSTitle: 'Other Colors',
      pdpExitIntentConfig: {
        pdpExitIntent: 'ON',
        pdpExitIntentTitle: 'Wait! Before You Leave',
        pdpExitIntentSubtitle: 'Explore these Similar Products',
        pdpExitIntentBackTitle: 'Continue to home',
        pdpExitIntentGoBackToProduct: 'Go back to product'
      },
      pdp_ui_configuration: {
        HEADER_MODEL: 1,
        PRODUCT_SCROLLER: 2,
        PRODUCT_INFO_MODEL: 3,
        COLOR_PRODUCT_SCROLLER: 3,
        ASSURED_QUALITY: 4,
        SIMILAR_MODEL_PRODUCT: 4,
        QUICK_LINKS: 5,
        METAL_PURITY: 6,
        PDP_ACTIONS: 6,
        PDP_DETAILS: 6,
        PRICE_REVEAL: 7,
        SIZE_MODEL: 7,
        PRICE_BREAKUP_MODEL: 7,
        EDD_MODEL: 8,
        BANK_OFFERS: 9,
        OFFER_MODEL: 10,
        COLOR_MODEL: 10,
        TRUST_MARKER: 12,
        RATING_AND_REVIEW_MODEL: 13,
        RETURN_MODEL: 14,
        REFERRAL_MODEL: 16,
        RV_MODEL: 19,
        FOOTER_MODEL: 20,
        PDP_MORE_INFORMATION: 21,
        PDP_KNOW_THE_PRODUCT: 22,
        YOU_MAY_ALSO_LIKE_MODEL: 23,
        PDP_INTERVENTIONS: 14,
        EXTERNAL_ADS_MODEL: 14,
        TREND_VIBE_WIDGET: 5
      }
    },
    enableGiftWithProduct: 'OFF',
    enableDefaultSizeSelection: 'OFF',
    giftWithProductConfig: {
      pdpFreebieTitle: 'Get ${count} Freebies',
      pdpHalfCardFreebieTitle: 'Get ${count} Freebies',
      olpFreebiesTitle: 'You have got ${count} Freebies with this product',
      olpFreebiesReturnTitle: 'Please Return ${count} Freebies with the product',
      gwpCartFreeBiesText: 'On completing combo purchase of ',
      gwpCartRemoveCartLevel: 'Freebies with this product may be removed',
      gwpCartRemoveProductLevel: 'Freebies with this product will be removed',
      productWidgetTitle: 'Get Freebies',
      orderDetailsFreebieText: 'Freebies with this product',
      odpSummary: ' (Incl. Freebies)',
      odpSingleFreebiesCancelText: 'Freebie will be canceled with the product',
      odpMultipleFreebiesCancelText: '${count} Freebies will be canceled with the product',
      odpSingleFreebiesText: 'Freebie with this product',
      odpMultipleFreebiesText: '${count} Freebies with this product',
      odpSingleReturnFreebiesText: 'Please Return Freebies with the product',
      odpMultipleReturnFreebiesText: 'Please Return ${count} Freebies with the product',
      odpSingleReturn2FreebiesText: 'For return Freebies are needed',
      odpMultipleReturn2FreebiesText: 'For return ${count} Freebies are needed',
      cancelModalSingleFreebiesText: 'Freebie will be canceled with the product',
      cancelModalMultipleFreebiesText: '${count} Freebies canceled with this product',
      cancelModalFreebieText: 'Freebie will be canceled with the product',
      odpSummary: ' (Incl. Freebies)'
    },
    emi_enabled: 'OFF',
    social_login: 'ON',
    enablePriorityDeliveryPreOrder: 'OFF',
    enablePriorityDeliveryPostOrder: 'OFF',
    priorityDeliveryConfig: {
      PD_ICON: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Tags-Priority-Tags-V2-1.png',
      SD_ICON: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Standard%20Delivery%20IC%20LUXE.png',
      SD_AJIOGRAM_ICON: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/SD_AJIOGRAM_ICON.svg',
      PD2_TRUCK_ICON: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Truck%20Animation%201x.gif',
      PD2_TRUCK_ICON_AJIOGRAM:
        'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/Ajiogram%20Truck%20Animation.gif',
      PDAlertTitle: 'Delivery change alert',
      odpWillInitiateRefund:
        'Unable to deliver via Priority Delivery. Hence, <b>refund of ₹{amount}</b> will be initiated to your AJIO Cash',
      odpRefundInitiated:
        'Refund of ₹{amount} Priority delivery fee has been initiated to AJIO Cash',
      odpRefunded: '₹{amount} Priority Delivery Fee has been refunded to AJIO Cash.',
      odpRefundedAjioCash: 'Go to Ajio Cash',
      odpRefundedAjioCashWeb: 'Ajio Cash',
      odpFreePriorityDelivery:
        'We regret not able to deliver via Priority Delivery. No refund will be initiated as Priority Delivery was free.',
      odpPriorityDeliveryTextForPackedAndShippedOrder:
        'This item will be delivered via Priority Delivery',
      odpPriorityDeliveryTextForDeliveredOrder: 'This item has been delivered via Priority Delivery'
    },
    enableEnchancedOosCart: 'OFF',
    luxeBottomIconStripUrl: 'https://assets-jiocdn.ajio.com/cms/GAP/WEB/Icon%20Strip-Desktop.jpg',
    barcodingPolyBagConfig: {
      enableBarcodingPolybag: 'ON',
      barcodingPolyBagGuidelineTitle: 'Where can I find the Unique Packet Code?',
      barcodingPolyBagGuidelineDescription:
        'This code is printed at the back of your AJIO order package. It has 11 characters. At the time of delivery, match this with the Unique packet code mentioned in order tracking section. The code will look something like this:'
    },
    ratingThreshold: {
      thresholdValue: 3,
      ratingBelowThresholdColor: '#A73535',
      ratingAboveThresholdColor: '#35A742'
    },
    enableSearchV4Endpoints: 'OFF',
    enableReturnProcessingFeePostOrder: 'OFF',
    returnProcessingFeePostOrderConfig: {
      order_section_title: 'Your returns are considerably high',
      order_section_desc:
        'A Return fee of ${amount} per product will be deducted from refund amount if you return the product.',
      modal_title: 'Why am I being charged a return fee?',
      modal_description:
        'We noticed that your returns in the past have been higher than average AJIO shopper.',
      return_and_refund_desc:
        'A Return fee of ${amount} per product will be deducted from refund amount if you return the product.',
      howitworks: {
        title: 'How it works ',
        description:
          'We assess your returns in comparison to other AJIO shoppers. Shoppers with returns that exceed the AJIO average by a large margin would be impacted.'
      },
      return_reason_screen: 'Return fee of ${amount} chargeable per item on return',
      return_item_detail_screen: 'Return Fee ${amount} chargeable per product on return',
      refund_breakup_modal: 'Charged per product per quantity',
      refund_breakup_ajio_fault: 'Fee not charged as the product you received was wrong/damaged ',
      possibleActions: {
        title: 'How to reduce returns',
        values: [
          {
            imageUrl: 'https://assets-jiocdn.ajio.com/sizeguide/exchange%20icon.png',
            alt_text: 'respSubtext',
            text: 'Exchange, not return'
          },
          {
            imageUrl: 'https://assets-jiocdn.ajio.com/sizeguide/tape%20icon.png',
            alt_text: 'respSubtext',
            text: 'Review Size Chart'
          },
          {
            imageUrl: 'https://assets-jiocdn.ajio.com/sizeguide/shirt%20icon.png',
            alt_text: 'respSubtext',
            text: 'Check Product Details'
          }
        ]
      },
      cta_hyper_link: 'Okay'
    },
    enableOspreySearch: 'OFF',
    enableComingSoonProducts: 'OFF',
    enableCODCheck: 'OFF',
    enableAjioMemberShipProgram: 'OFF',
    ajioMemberShipConfig: {
      isEnableForPLP: false,
      isEnableForPDP: false,
      isEnableForSPC: false,
      isEnableForCart: false,
      isEnableForThankyou: false,
      isEnableForAccount: false,
      isEnableForHomePage: false,
      isEnablePostOrder: false,
      cartAutoAdd: false,
      cartShowSubscriptionCard: false,
      coachMarkConfigs: {
        isEnabled: false,
        timeout: 5000
      },
      membershipName: 'AJIO FIRST SUBSCRIPTION',
      subscription_account_icon_url:
        'https://assets-uat.ajio.ril.com/cms/AJIO/MOBILE/Account_icon220x18.png',
      subscription_account_icon_url_ajiogram:
        'https://assets-uat.ajio.ril.com/cms/AJIO/MOBILE/Account_icon220x18.png'
    },
    subscriptionBannerConfig: {
      bannerHeading: 'AJIO First Membership',
      bannerBenefitText: 'Subscribe to the AJIO First Membership and enjoy multiple benefits'
    },
    showSelectedFiltersTab: 'OFF', //flag to show selected filters tab in msite
    appsFlyerConfig: {
      oneLinkURL: 'https://ajioapps.onelink.me/2ic3',
      webReferrer: 'af_channel',
      afParameters: {
        mediaSource: { keys: ['utm_source', 'utm_medium'], defaultValue: 'AF_script' },
        campaign: { keys: ['utm_campaign'] },
        afCustom: [
          { paramKey: 'utm_source', keys: ['utm_source'] }, //utm_source
          { paramKey: 'utm_medium', keys: ['utm_medium'] }, //utm_medium
          { paramKey: 'utm_campaign', keys: ['utm_campaign'] }, //utm_campaign
          { paramKey: 'af_ss_ui', defaultValue: 'true' } //custom_ss_ui
        ],
        googleClickIdKey: 'af_sub1',
        afSub2: { keys: ['fbclid'] }
      }
    },
    enableCrossSell: 'OFF',
    newShowClosedBoxToOpenBox: 'OFF',
    dressToolPdpBannerConfig: {
      showBanner: true,
      imgUrl: '',
      visibilityConditions: {
        Women: ['Bras', 'Blouses', 'Shirts, Tops & Tunics', 'Tops']
      }
    },
    dressToolAtcPopupConfig: {
      showPopup: true,
      title: 'Woah! That’s a great choice!',
      subTitle:
        'Need help finding a bra that pairs perfectly with this dress? We are here to help!',
      imgUrl: '',
      visibilityConditions: {
        Women: ['Bras', 'Blouses', 'Shirts, Tops & Tunics', 'Tops']
      }
    },
    accountDeletionFeatureConfig: {
      isAccountDeletionEnable: 'OFF',
      youDataHeader: 'Your Data',
      yourDataContent: `We value your trust. AJIO ensures that your data remains safe and protected, without
      being shared for external marketing, advertising, or other uses.`,
      reasonScreenConfig: {
        heading: 'Please read carefully before proceeding',
        readPolicy:
          'Your account will be deleted in 30 days and you will lose access to all your data and order history. You will not be able to recover your account in future and will be logged out after your confirmation. You won’t be able to use your Email and Phone Number linked with this account to login or create new account for those 30 days.\n\nIf you decide later that you want to start ordering from us again, or if you would like to use websites features that require an account, you’ll need to create a new account. .\n\nAjio will retain your transaction history.',
        reasonDropdownHeading: 'Please tell why you are deleting your account?',
        dropdownReasons: ['Privacy Concerns', 'Account Hacked', 'Don’t find it useful']
      },
      accountDeletionHeader: 'Account Deletion Request Submitted',
      accountDeletionContent: `Your account will be permanently deleted in 30 days. You’ve been logged out. If you
      wish to retrieve your account within this period, please contact customer care.`
    },
    pdpVideosFeatureConfig: {
      enableVideosOnPDP: 'OFF',
      autoPlay: 'ON'
    },
    promoteExchangeMsiteConfig: {
      enableReturnExchangeSegregation: 'OFF',
      enableNudgeExchange: 'OFF',
      nudgeExchangeTitle: 'Do you want to consider exchange instead of return?',
      nudgeExchangeTagLine: 'A sustainable alternative for a better tomorrow',
      nudgeNonRefundableAndDiscountCallout: 'OFF',
      nudgeHighReturnCallout: 'OFF',
      nudgeNonRefundableAndDiscountCalloutPosition: '1',
      nudgeHighReturnCalloutPosition: '2',
      enableTryExchangeNudge: 'OFF'
    },
    promoteExchangeWebConfig: {
      enableReturnExchangeSegregation: 'ON',
      enableNudgeExchange: 'ON',
      nudgeExchangeTitle: 'Do you want to consider exchange instead of return?',
      nudgeExchangeTagLine: 'A sustainable alternative for a better tomorrow',
      nudgeNonRefundableAndDiscountCallout: 'ON',
      nudgeHighReturnCallout: 'ON',
      nudgeNonRefundableAndDiscountCalloutPosition: '1',
      nudgeHighReturnCalloutPosition: '2',
      enableTryExchangeNudge: 'ON'
    },
    priorityDeliveryPhase2: 'OFF',
    enableRushDelivery: 'OFF',
    priorityDeliverySLPTagsConfig: {
      PDP_BUCKET: {
        SDD: 'Delivery by <strong>Today</strong>',
        NDD: 'Delivery by <strong>Tomorrow</strong>',
        '2DD': 'Delivery in <strong>2 Days</strong>, {deliveryDay}',
        '4HR': 'Delivery in <strong>4 hours</strong>',
        '2HR': 'Delivery in <strong>2 hours</strong>',
        '1HR': 'Delivery in <strong>1 hour</strong>',
        '30MIN': 'Delivery in <strong>30 minutes</strong>'
      },
      TY_BUCKET: {
        SDD: 'Today',
        NDD: 'Tomorrow',
        '2DD': '2 days',
        '4HR': 'Today by',
        '2HR': 'Today by',
        '1HR': 'Today by',
        '30MIN': 'Today by'
      },
      PLP_BUCKET: {
        SDD: 'Today',
        NDD: 'Tomorrow',
        '2DD': '2 Days',
        '4HR': '4 hours',
        '2HR': '2 hours',
        '1HR': '1 hour',
        '30MIN': '30 minutes'
      },
      FILTERS_BUCKET: {
        commonFilter: true,
        visible: true,
        code: 'sla',
        values: [
          {
            code: '30MIN',
            deliveryMethod: 'RUSH',
            query: {
              url: ''
            },
            name: 'Within 30 Mins',
            count: 0,
            selected: false,
            priorityId: 0
          },
          {
            code: '1HR',
            deliveryMethod: 'RUSH',
            query: {
              url: ''
            },
            name: 'Within 60 Mins',
            count: 0,
            selected: false,
            priorityId: 1
          },
          {
            code: '2HR',
            deliveryMethod: 'RUSH',
            query: {
              url: ''
            },
            name: 'Within 2 Hours',
            count: 0,
            selected: false,
            priorityId: 2
          },
          {
            code: '4HR',
            deliveryMethod: 'RUSH',
            query: {
              url: ''
            },
            name: 'Within 4 Hours',
            count: 0,
            selected: false,
            priorityId: 3
          },
          {
            code: 'SDD',
            deliveryMethod: 'PRIORITY',
            query: {
              url: ''
            },
            name: 'Today',
            count: 0,
            selected: false,
            priorityId: 4
          },
          {
            code: 'NDD',
            deliveryMethod: 'PRIORITY',
            query: {
              url: ''
            },
            name: 'Tomorrow',
            count: 0,
            selected: false,
            priorityId: 5
          },
          {
            code: '2DD',
            deliveryMethod: 'PRIORITY',
            query: {
              url: ''
            },
            name: 'In 2-Days',
            count: 0,
            selected: false,
            priorityId: 6
          }
        ],
        hideIfCurated: false,
        name: 'Delivery',
        category: false,
        multiSelect: false
      }
    },
    ajiogramInterventionsConfig: {
      plpConfig: {
        enableIntervention: false,
        tagContent: {
          logo: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/OG%20Logo_Large.png',
          text: '#AJIOGRAM',
          backgroundColor: '#ECEF41',
          textColor: '#202020'
        }
      },
      pdpConfig: {
        enableIntervention: false,
        tagContent: {
          logo: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/OG%20Logo_Large.png',
          text: '#AJIOGRAM',
          backgroundColor: '#ECEF41',
          textColor: '#202020'
        },
        widgetContent: {
          widgetTitle: 'Explore more styles on AJIO Drip',
          widgetLogo: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/OG%20Logo_Large.png',
          buttonLogo: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/OG%20Logo_Large.png',
          buttonTitle: 'Visit #AJIOGRAM Store',
          buttonTitleColor: '#202020',
          buttonBackgroundColor: '#D2D50C',
          maxProductsCount: 20,
          redirectionUrl: 'https://qa-ajiogram.services.ajio.com'
        }
      }
    },
    better_pdp_config: {
      isEnabled: 'ON',
      max_key_value_pair: 20,
      isSectionOneTabularView: 'ON',
      isSectionTwoTabularView: 'ON',
      isSectionThreeTabularView: 'ON',
      max_line_for_value: 3,
      better_pdp_title: 'Product Details'
    },
    ajiogramLandingPage: 'OFF',
    appRefundRevampFlow: 'ON',
    paymentAndRefundCreditConfig: {
      showPaymentAndRefundCreditModes: 'ON',
      showPaymentModesOnOrderPlacement: 'ON',
      showRefundCreditModesOnReturn: 'ON',
      showRefundCreditModesOnCancellation: 'OFF',
      downloadAppBannerText: 'For better Experience, download AJIO app.'
    },
    bannerCmsJioAdsConfig: {
      cmsAdsBannerSizeMsite: '1024x672',
      bannerAdConfigForCart: {
        isBannerAdEnabled: 'OFF',
        isClickEnabled: 'OFF',
        pageUrl: '/cart/banner',
        isJioBannerAdsEnabled: 'OFF',
        isJioBannerAdsClickEnabled: 'OFF',
        isJioBannerDynamicAdsEnabled: 'OFF',
        jioAdsAsi: 'cwi80vmt',
        jioAdsPageUrl: 'cart_banner'
      },
      bannerAdConfigForPdp: {
        isBannerAdEnabled: 'OFF',
        isClickEnabled: 'OFF',
        pageUrl: '/pdp/banner',
        isJioBannerAdsEnabled: 'OFF',
        isJioBannerAdsClickEnabled: 'OFF',
        isJioBannerDynamicAdsEnabled: 'OFF',
        jioAdsAsi: 'uf2bvler',
        jioAdsPageUrl: 'pdp_banner'
      },
      bannerAdConfigForMyAccount: {
        isBannerAdEnabled: 'OFF',
        isClickEnabled: 'OFF',
        pageUrl: '/myaccount/banner',
        isJioBannerAdsEnabled: 'OFF',
        isJioBannerAdsClickEnabled: 'OFF',
        isJioBannerDynamicAdsEnabled: 'OFF',
        jioAdsAsi: 'ypfcqv5s',
        jioAdsSdkAsi: 'np95odtz',
        jioAdsSdkDimension: '300x50,300x250,320x50,320x100',
        jioAdsPageUrl: 'myaccount_banner'
      },
      bannerAdConfigForOrderListing: {
        isBannerAdEnabled: 'OFF',
        isClickEnabled: 'OFF',
        pageUrl: '/orderlisting/banner',
        isJioBannerAdsEnabled: 'OFF',
        isJioBannerAdsClickEnabled: 'OFF',
        isJioBannerDynamicAdsEnabled: 'OFF',
        jioAdsAsi: 'hme301rn',
        jioAdsSdkAsi: 'syrv7af6',
        jioAdsSdkDimension: '300x50,300x250,320x50,320x100',
        jioAdsPageUrl: 'orderlisting_banner'
      },
      bannerAdConfigForThankyou: {
        isBannerAdEnabled: 'OFF',
        isClickEnabled: 'OFF',
        pageUrl: '/thankyou/banner',
        isJioBannerAdsEnabled: 'OFF',
        isJioBannerAdsClickEnabled: 'OFF',
        isJioBannerDynamicAdsEnabled: 'OFF',
        jioAdsAsi: 'wkiz0vrm',
        jioAdsSdkAsi: 'e9us06o3',
        jioAdsSdkDimension: '300x50,300x250,320x50,320x100',
        jioAdsPageUrl: 'thankyou_banner'
      },
      jioAdsConfigMisc: {
        apiTimeout: '1'
      },
      GABundleSize: 2,
      CMSADsExperiments: 'CMSABExp2,CMSABExp7,CMSABExp9,CMSABExp5'
    },
    seoCategoryMetadataTemplate: {
      metaTitle: 'Buy ${filterValue} ${categoryName} Online in India | Ajio',
      metaKeywords:
        '${filterValue} ${categoryName}, ${filterValue} ${categoryName} Online, ${filterValue} ${categoryName} Online shopping, Buy ${filterValue} ${categoryName} Online, Buy ${filterValue} ${categoryName}',
      metaDescription:
        "Shop ${filterValue} ${categoryName} at Best Prices Online in India. Discover a wide selection of ${filterValue} ${categoryName} at Ajio, India's leading Online Shopping destination."
    },
    seoBrandMetadataTemplate: {
      metaTitle: 'Buy ${brandName} ${filterValue} ${categoryName} Online in India | Ajio',
      metaKeywords:
        "Shop ${brandName} ${filterValue} ${categoryName} at Best Prices Online in India. Discover a wide selection of ${brandName} ${filterValue} ${categoryName} at Ajio, India's leading Online Shopping destination.",
      metaDescription:
        '${brandName} ${filterValue} ${categoryName}, ${brandName} ${filterValue} ${categoryName} Online, ${brandName} ${filterValue} ${categoryName} Online shopping, Buy  ${brandName} ${filterValue} ${categoryName} Online, Buy  ${brandName} ${filterValue} ${categoryName}'
    },
    plponlanding: {
      enablePlpOnLanding: 'OFF',
      enableTitle: 'ON',
      showFilter: true,
      productConfig: {
        showDesc: true,
        showOffer: true,
        showPrice: true,
        showWishlist: true,
        showProductTag: true,
        showUrgencyTags: true,
        showProductRating: true
      },
      showBackToTopMaxLimit: 24,
      showBackToTopMinLimit: 10,
      filterTabsConfig: [
        {
          code: 'allfilters',
          name: 'Filter',
          tabPosition: 0
        },
        {
          code: 'sort',
          name: 'Sort By',
          tabPosition: 1
        },
        {
          code: 'l1l3nestedcategory',
          name: 'Category',
          tabPosition: 2
        },
        {
          code: 'genderfilter',
          name: 'Gender',
          tabPosition: 3
        },
        {
          code: 'pricerange',
          name: 'Price',
          tabPosition: 4
        },
        {
          code: 'brand',
          name: 'Brands',
          tabPosition: 5
        },
        {
          code: 'occasion',
          name: 'Occasion',
          tabPosition: 6
        }
      ]
    },
    ajioCashMopList: [
      'RETURN_CREDIT',
      'AJIO_CASH_NT_WALLET',
      'REFERRAL',
      'FINANCE_PROMOTION',
      'GAMIFICATION_CREDIT',
      'GIFTCARD_CREDIT',
      'COD_REFUND',
      'APPEASEMENT'
    ],
    referallFriendConfig: {
      oldFlow: 'ON',
      componentUrl:
        'https://jioplayalong4.akamaized.net/ajio-poc-referral/dev/je-referral-client.js'
    },
    enableNewCohortFlow: 'OFF',
    rushDeliveryErrorMsgs: [
      {
        code: 'RUSH_DETAILS_CHANGED',
        title: 'Delivery has changed',
        msg: 'Rush details have changed for {productsCount} products in your Cart.'
      },
      {
        code: 'RUSH_LAT_LONG_REQUIRED',
        title: 'Rush has changed',
        msg: 'Lat/Long is required for Rush'
      },
      {
        code: ' RUSH_AND_PD_MAX_CAPPING_REACHED',
        title: 'Max cap has reached',
        msg: 'You have reached max limit for rush and priority fee'
      },
      {
        code: 'RUSH_MAX_CAPPING_REACHED',
        title: 'Max cap has reached',
        msg: 'You have reached max limit for rush fee'
      },
      {
        code: ' PD_MAX_CAPPING_REACHED',
        title: 'Max cap has reached',
        msg: 'You have reached max limit for priority fee'
      }
    ],
    googleMapsApiKey: 'AIzaSyCSORKWOeVmiohHaCoEtm7spBSqMYQlVDQ',
    rushAvailabilityCookieExpireTimeInHours: 1,
    coachMarkRushConfig: {
      coachMarkTitle: 'Quicker Delivery options available!',
      coachMarkSubTitle:
        'Select an exact location to see if we can offer quicker delivery options for you'
    },
    return_flow_optimization_msite: {
      master: false,
      return_exchange_enabled: false,
      customer_care_enabled: false,
      return_cancel_enabled: false,
      return_request_reason_enabled: false,
      return_request_reason_desc:
        'Select the appropriate return reason to ensure smooth pickup and refund processing.',
      return_cancel_popup_title: 'Cancel Return?',
      return_cancel_popup_desc:
        'Cancellation request for Return ID: %s will be taken and we will try to cancel it!',
      return_cancel_popup_timeline:
        'It usually takes 24 - 48 hours for the cancellation request to get processed.',
      return_cancel_popup_success_title: 'Cancellation Requested'
    },
    return_flow_optimization_web: {
      master: false,
      return_exchange_enabled: false,
      customer_care_enabled: false,
      return_cancel_enabled: false,
      return_request_reason_enabled: false,
      return_request_reason_desc:
        'Select the appropriate return reason to ensure smooth pickup and refund processing.',
      return_cancel_popup_title: 'Cancel Return?',
      return_cancel_popup_desc:
        'Cancellation request for Return ID: %s will be taken and we will try to cancel it!',
      return_cancel_popup_timeline:
        'It usually takes 24 - 48 hours for the cancellation request to get processed.',
      return_cancel_popup_success_title: 'Cancellation Requested'
    },
    return_flow_optimization_msite: {
      master: false,
      return_exchange_enabled: false,
      customer_care_enabled: false,
      return_cancel_enabled: false,
      return_request_reason_enabled: false,
      return_request_reason_desc:
        'Select the appropriate return reason to ensure smooth pickup and refund processing.',
      return_cancel_popup_title: 'Cancel Return?',
      return_cancel_popup_desc:
        'Cancellation request for Return ID: %s will be taken and we will try to cancel it!',
      return_cancel_popup_timeline:
        'It usually takes 24 - 48 hours for the cancellation request to get processed.',
      return_cancel_popup_success_title: 'Cancellation Requested'
    },
    return_flow_optimization_web: {
      master: true,
      return_exchange_enabled: true,
      customer_care_enabled: true,
      return_cancel_enabled: true,
      return_request_reason_enabled: true,
      return_request_reason_desc:
        'Select the appropriate return reason to ensure smooth pickup and refund processing.',
      return_cancel_popup_title: 'Cancel Return?',
      return_cancel_popup_desc:
        'Cancellation request for Return ID: %s will be taken and we will try to cancel it!',
      return_cancel_popup_timeline:
        'It usually takes 24 - 48 hours for the cancellation request to get processed.',
      return_cancel_popup_success_title: 'Cancellation Requested'
    },
    userRelevancy: 'OFF',
    bank_discount_clawback: {
      master: true,
      cancel_desc:
        'Canceling this item reduces the order value below the required amount, making the below bank discount ineligible:',
      return_desc:
        'Returning this item reduces the order value below the required amount, making the below bank discount ineligible:'
    },
    ajioSuperCashConfig: {
      enable: 'OFF',
      ajioCashCurrency: {
        currencyName: 'SuperCash',
        currencyPrimaryLogo:
          'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
        currencySecondaryLogo:
          'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Shortform-Logo.svg'
      },
      superCashBalance: 'SuperCash balance',
      homePageConfig: {
        enable: 'OFF',
        bottomStripConfig: {
          autoScrollTimer: '3',
          minimumSuperCashBalance: '50',
          expiringSuperCashBalance: '150',
          expiringSuperCashDays: '5',
          indicatorBackground: '#C4C4C4',
          indicatorForeground: '#2C4152',
          minimumDaysDateThresold: '10',
          maximumMessageLength: '100',
          enableSticky: 'OFF',
          slides: [
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template: 'You have ₹{super_cash} Supercash available. Use it now!',
              priority: 1,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              earningSlide: true,
              userType: 'loggedin',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template:
                '₹{expire_super_cash} Supercash is expiring {expiry_date}. Use it before it’s gone!',
              priority: 2,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              expiringSlide: true,
              userType: 'loggedin',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/ajio_offer_icon_2_3x.png',
              template: 'Get 15% SuperCash on every order! Redeem anytime, no conditions',
              priority: 3,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              staticSlide: true,
              userType: 'all',
              stripTextColor: '#202020',
              stripGradientStartColor: '#F4FFF5',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template: 'Get 15% SuperCash on every order! Redeem anytime, no conditions',
              priority: 4,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              staticSlide: true,
              userType: 'guest',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            }
          ]
        }
      },
      plpConfig: {
        enable: 'OFF',
        bottomStripConfig: {
          autoScrollTimer: '3',
          minimumSuperCashBalance: '50',
          expiringSuperCashBalance: '150',
          expiringSuperCashDays: '5',
          indicatorBackground: '#C4C4C4',
          indicatorForeground: '#2C4152',
          minimumDaysDateThresold: '10',
          maximumMessageLength: '100',
          enableSticky: 'OFF',
          slides: [
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template: 'You have ₹{super_cash} Supercash available. Use it now!',
              priority: 1,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              earningSlide: true,
              userType: 'loggedin',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template:
                '₹{expire_super_cash} Supercash is expiring {expiry_date}. Use it before it’s gone!',
              priority: 2,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              expiringSlide: true,
              userType: 'loggedin',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/ajio_offer_icon_2_3x.png',
              template: 'Get 15% SuperCash on every order! Redeem anytime, no conditions',
              priority: 3,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              staticSlide: true,
              userType: 'all',
              stripTextColor: '#202020',
              stripGradientStartColor: '#F4FFF5',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template: 'Get 15% SuperCash on every order! Redeem anytime, no conditions',
              priority: 4,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              staticSlide: true,
              userType: 'guest',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            }
          ]
        }
      },
      pdpPageConfig: {
        enable: 'OFF',
        pdpSuperCashTitle: 'Extra ₹{super_cash} SuperCash',
        bottomStripConfig: {
          autoScrollTimer: '3',
          minimumSuperCashBalance: '50',
          expiringSuperCashBalance: '150',
          expiringSuperCashDays: '5',
          indicatorBackground: '#C4C4C4',
          indicatorForeground: '#2C4152',
          minimumDaysDateThresold: '10',
          maximumMessageLength: '100',
          enableSticky: 'OFF',
          slides: [
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template: 'You have ₹{super_cash} Supercash available. Use it now!',
              priority: 1,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              earningSlide: true,
              userType: 'loggedin',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template:
                '₹{expire_super_cash} Supercash is expiring {expiry_date}. Use it before it’s gone!',
              priority: 2,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              expiringSlide: true,
              userType: 'loggedin',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo: 'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/ajio_offer_icon_2_3x.png',
              template: 'Get 15% SuperCash on every order! Redeem anytime, no conditions',
              priority: 3,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              staticSlide: true,
              userType: 'all',
              stripTextColor: '#202020',
              stripGradientStartColor: '#F4FFF5',
              stripGradientEndColor: '#F4F8FF'
            },
            {
              slideLogo:
                'https://assets-jiocdn.ajio.com/cms/AJIO/MOBILE/AJIO-SuperCash-Longform-Logo.svg',
              template: 'Get 15% SuperCash on every order! Redeem anytime, no conditions',
              priority: 4,
              redirectionUrl: '/my-account/ajio-wallet-bonus',
              staticSlide: true,
              userType: 'guest',
              stripTextColor: '#22419E',
              stripGradientStartColor: '#DAE7FF',
              stripGradientEndColor: '#F4F8FF'
            }
          ]
        }
      },
      cartPageConfig: {
        enable: 'OFF',
        superCashTitle: 'You are earning {super_cash} SuperCash!',
        superCashSubtitle: 'Amount will be credited after 15 days of delivery',
        subscriptionXsuperCashTitle: 'You are earning {super_cash} SuperCash with subscription!',
        subscriptionXsuperCashSubtitle: 'Amount will be credited after 25 days of delivery',
        stripCta: 'Know More',
        tAndCLink: 'https://ajio.com',
        halfCardCta: 'T&C',
        halfCardDescription:
          'SuperCash is a cashback programme introduced to allow customers to get upto 15% Cashback on every purchase. This scheme is 100% redeemable. Cashback earned will be credited to your AJIO Wallet, once the return window closes'
      },
      paymentPageConfig: {
        enable: 'OFF',
        oldFlow: 'OFF',
        halfCardSubText: 'Use {percentage} of the SuperCash value on any order',
        halfCardNotApplicableText: 'SuperCash is not applicable on the following products'
      },
      orderDetailPageConfig: {
        enable: 'OFF',
        superCashTitle: 'Check your SuperCash earnings',
        superCashCtaText: 'Details'
      },
      walletPageConfig: {
        enable: 'OFF',
        expiryDateTemplate: '₹{expire_super_cash} SuperCash expiring on {expiry_date}',
        expiryDayTemplate: '₹{expire_super_cash} SuperCash expiring in {expiry_date} days',
        daysThreshold: 10,
        stripTextColor: ' #22419E',
        stripGradientStartColor: '#DAE7FF',
        stripGradientEndColor: '#F4F8FF'
      },
      thankYouPageConfig: {
        enable: 'OFF'
      }
    },
    segment_tracking_enabled: 'ON',
    assetConfig: {
      isJioCDNEnabled: 'OFF',
      jioCDNAssetUrl: 'https://ajioassets.cdn.jio.com',
      isJioCDNJsCssFetchEnabled: 'OFF',
      assetUrls: [
        'https://assets.ajio.com',
        'https://assets-uat.ajio.ril.com',
        'https://qashein-assets-uat.ajio.ril.com',
        'https://ajio-assets-uat.akamaized-staging.net'
      ]
    },
    widgetCoverageFlags: {
      enableWidgetCoverageMaster: 'OFF',
      enableWidgetCoverageSearchPage: 'OFF',
      enableWidgetCoveragePLP: 'OFF',
      enableWidgetCoveragePDP: 'OFF',
      enableWidgetCoverageThankYou: 'OFF'
    },
    plpProductLoadMargin: '400px',
    vertexEnabled: 'OFF',
    vertexEnabledForSis: false,
    vertexEnabledAjiogram: {
      master: false,
      vertexAutoSuggestEnabled: false,
      vertexSearchEnabled: false,
      vertexBrowseEnabled: false
    },
    vertexEnabledLuxe: {
      master: false,
      vertexAutoSuggestEnabled: false,
      vertexSearchEnabled: false,
      vertexBrowseEnabled: false
    },
    copilotConfig: {
      copilotMsiteEnabled: 'OFF',
      copilotDesktopEnabled: 'OFF',
      copilotWhitelistedPagesDesktop: [
        '/c/',
        '/p/',
        '/b/',
        '/search/',
        '/shop/',
        '/home',
        '/my-account/'
      ],
      copilotWhitelistedPagesMsite: [
        '/c/',
        '/p/',
        '/b/',
        '/search/',
        '/shop/',
        '/home',
        '/my-account/',
        '/feed/',
        '/explore/'
      ],
      copilotWhitelistedStoresDesktop: ['ajio', 'luxe', 'ajiogram'],
      copilotWhitelistedStoresMsite: ['ajio', 'luxe', 'ajiogram'],
      hideIngressDesktop: ['/my-account/'],
      hideIngressMsite: ['/my-account/']
    },
    disableFloatingWidgetDrag: 'OFF',
    urgencyDriverV2MsiteConfig: {
      enableMaster: 'OFF',
      plpPage: {
        enable: 'OFF',
        experimentName: 'A'
      },
      pdpPage: {
        enable: 'OFF',
        experimentName: 'A'
      },
      cartPage: {
        enable: 'OFF',
        experimentName: 'A'
      }
    },
    amplitude_experiment_flag: 'OFF',
    plaAdsFlags: {
      plaAdsFlags: {
        enableMaster: false,
        pdp_page: {
          minNumOfProducts: 1,
          isEnabled: false,
          isTopAdEnabled: false,
          isAdsEnabled: false,
          removeDuplicates: false
        },
        jioAdsParams: {
          pfa: '1111',
          pla: 1,
          ai: 'com.ril.ajio',
          mcr: 1,
          vr: 'A-AN-1.2',
          os: '1'
        }
      }
    },
    sizeRecommendationConfig: {
      enable: 'OFF',
      environment: 'sit',
      accessToken: 'e5a9f4196ff1d9af771dd1f298b1fbcd4fa889d856bcc2bc489e7f39e4b0d5d8',
      storeType: ['ajio', 'luxe', 'ajiogram'],
      iconUrls: {
        ajio: 'https://assets-uat.ajio.ril.com/cms/AJIO/MOBILE/fyndsize.png',
        ajiogram: 'https://assets-uat.ajio.ril.com/cms/AJIO/MOBILE/fyndsize.png',
        luxe: 'https://assets-uat.ajio.ril.com/cms/AJIO/MOBILE/fyndsize_luxe.png'
      },
      texts: {
        findYourSizeText: 'Find your recommended size',
        noSizeRecommendedText: 'No size recommendation available',
        sizeText: 'Size ${XXXL}',
        recommendedSizeText: 'is recommended basis your inputs.',
        editCTA: 'Edit info',
        tryAgaingText: 'Hmm, something’s off.',
        tryAgainCTA: 'Try again',
        toolOfflineText: 'Oops, the tool’s offline. Please try later.'
      },
      sizeConfig: [
        {
          segment: 'Men',
          vertical: 'Western Wear',
          brick: 'Shirts'
        },
        {
          segment: 'Men',
          vertical: 'Western Wear',
          brick: 'Jeans'
        },
        {
          segment: 'Men',
          vertical: 'Western Wear',
          brick: 'Jackets & Coats'
        },
        {
          segment: 'Men',
          vertical: 'Western Wear',
          brick: 'Trousers & Pants'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Dresses'
        },
        {
          segment: 'Men',
          vertical: 'Western Wear',
          brick: 'Sweatshirts & Hoodie'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Jeans & Jeggings'
        },
        {
          segment: 'Men',
          vertical: 'Western Wear',
          brick: 'Track Pants'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Tops'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Sweaters & Cardigans'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Sweatshirts &Hoodies'
        },
        {
          segment: 'Men',
          vertical: 'Western Wear',
          brick: 'Blazers & Waistcoats'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Dresses & Gowns'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Tshirts'
        },
        {
          segment: 'Men',
          vertical: 'Western Wear',
          brick: 'Shorts & 3/4ths'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Leggings'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Shirts'
        },
        {
          segment: 'Women',
          vertical: 'Western Wear',
          brick: 'Bras'
        }
      ]
    },
    enableGST: 'OFF',
    gstCohort: ['gstcohort1'],
    gstConfig: {
      common: {
        gstExpiredTag: 'Expired'
      },
      cart: {
        sectionTitle: 'Save up to 24% with GST benefits',
        checkBoxLabel: 'Use GST Invoice',
        validateGSTConsentMessage: 'Add & use this GST for all future orders.',
        termsAndConditionURL: 'https://www.ajio.com/help/termsAndCondition',
        validateAddressSubHeading:
          'For GST benefits, the city and pincode must match your GST registered address.',
        revalidatingStateMessage: 'Re-validating the data with GST records…',
        gstAppliedToOrderSuccessMessage: 'Success! GST verified and applied to your order.',
        revalidateAddressError:
          'Address has been updated, re-validate your address to retain benefits.',
        someIneligibleItemsInCart: "Some items in your cart aren't eligible for GST invoice.",
        allIneligibleItemsInCart: "All items in your cart aren't eligible for GST invoice.",
        someIneligibleTitle: "{num} items in your cart aren't eligible for GST invoice.",
        allIneligibleTitle: "All items in your cart aren't eligible for GST invoice.",
        someIneligibleItemsToastMsg: 'Non-GST items removed to enable GST billing.',
        allIneligibleItemsToastMsg: 'Non-GST items removed to from your cart',
        savedGSTExpiredErrorMessage:
          'Your GST is expired. Kindly use different GST to avail the benefits.',
        maxProfileTooltip:
          'A maximum of 5 GST entries is allowed. Please delete an existing GST entry to add a new one.',
        maxProfileNote:
          'Note: A maximum of 5 GST entries is allowed. Please delete an existing GST entry to proceed.',
        movedToWishlistMsg: 'The product(s) has been successfully moved to your wishlist',
        noSavedGSTTitle: 'No Saved GST Details',
        noSavedGSTSubHeading: 'Please add a new GST number to continue with GST invoice benefits.',
        deleteSavedGSTTitle: 'Are you sure you want to delete?',
        deleteSavedGSTMsg:
          'Deleting this will erase all the stored data linked to this GST number.',
        previewInelibileItemsNote:
          'Note: Non-GST items will be moved to your wishlist if you proceed with GST.',
        panCardVerificationNote:
          'Note: Please make sure the “Business name on PAN Card” matches with your “GST business name”',
        returnRefundPolicyMessage: 'Exchange not available for GST Orders',
        confirmChangeAddressTitle: 'Are you sure you want to change address?',
        confirmChangeAddressDescription:
          "By changing the address, you'll need to re-validate it with your GST details to claim the benefits.",
        shippingPageAddressChangedMessage:
          'Your GST benefits require address re-validation due to a recent address change. Please re-validate the address to claim the benefits.',
        shippingPageAddressChangedTooltip:
          'Your address has been changed. Please re-validate the new address before proceeding with the payment.',
        autoFilledPanDetailsToastMsg: "We've autofilled the previously used PAN details",
        serverDownErrorMessage: 'GST server is currently down. Please try again later.'
      },
      odp: {
        generalMessage: [
          'GST invoice will be issued only if GST is valid at the time of delivery/return.',
          'Cancelled items are not eligible for GST invoices.'
        ],
        gstExpiredError: 'Your GST is expired. A regular invoice will be issued for this order.',
        returnNote: 'Note: GST details will be re-verified once the product reaches our warehouse.',
        cancelError: 'Cancelled item will not be included in the GST invoice.',
        businessCancellationMessage:
          'We had to cancel your order as the GST number provided was expired at the time of verification.',
        selectAddressWarning: 'Address change is not allowed for GST orders',
        faqs: [
          {
            question: 'How to download GST Invoice?',
            answers: [
              '{DownloadInvoice} from here',
              'For returned items you will get Refund Credit Note against each returned item.',
              "Invoice won't be available for the returned items."
            ]
          },
          {
            question: 'What does "GST expired" mean?',
            answers: [
              'It means your GST number has expired and needs to be reactivated on the Government GST portal.',
              'If your GST number is expired at the time of delivery or during a return, a regular invoice will be issued instead of a GST invoice.',
              'GST details will be re-verified once the product reaches our warehouse. If the GST number is inactive at that time, a regular invoice will be issued.'
            ]
          }
        ]
      }
    },
    bankDiscountClawBackConfig: {
      bankDiscountTitle: 'Order Bank Discount Deducted',
      _comment: 'This is a master flag for entire feature.',
      cancel: {
        refundBreakBankClawbackText:
          'Canceling this item reduces the order value below the required amount, making the below bank discount ineligible:',
        refundBreakBankClawbackTextCancelled:
          'Item cancelation has reduced the order value below the required amount, making the below bank discount ineligible',
        zeroRefundMessage:
          'No refund, as item price is lower than the availed bank discount. Refer Refund breakup for more info!'
      },
      checkout: {
        bankOfferSummary:
          'This discount will be recovered in case of Return/Cancelation, if the order goes below the offer threshold.'
      },
      howBankDiscountWorks: {
        bankDiscountNotes: [
          'Return or cancellation reduces the order amount.',
          'If the order value falls below the minimum required to avail the bank discount, the discount will be deducted upon cancellation or return.',
          'Deduction of discount amount will happen from the item being returned or canceled under the same Order ID.',
          'User will receive no refund, if the item price is lower than the availed bank discount.'
        ],
        title: 'How Bank discount works:'
      },
      isEnabled: true,
      refundBreakUpKnowMoreCta: 'Know more',
      returnData: {
        refundBreakBankClawbackText:
          'Returning this item reduces the order value below the required amount, making the below back discount ineligible',
        refundBreakBankClawbackTextReturned:
          'Item return has reduced the order value below the required amount, making the below bank discount ineligible',
        wis_info:
          'Bank discount & other fees will not be deducted, subject to successful verification of the return'
      }
    },
    filterImprovement: {
      isEnabled: false,
      isPhase2Enabled: false,
      gender: {
        title: 'Shop For',
        primaryHeader: 'Gender',
        secondaryHeader: 'Others',
        genderFilterApparels: [
          'Women',
          'Men',
          'Girls',
          'Boys',
          'Infants',
          'Junior Girls',
          'Junior Boys'
        ]
      },
      category: {
        otherTitle: 'All Categories',
        suggestedTitle: 'Suggested Categories'
      },
      brand: {
        suggestedTitle: 'Suggested Brands'
      }
    },
    emidiscountconfig: {
      masterFlag: false,
      platforms: {
        ajio: {
          emiOnPDP: false,
          emiOnPayment: false,
          offerOrder: ['coupon', 'emiOffer', 'bankOffer'],
          thresholdAmount: 3000
        },
        ajiogram: {
          emiOnPDP: false,
          emiOnPayment: false,
          offerOrder: ['coupon', 'emiOffer', 'bankOffer'],
          thresholdAmount: 3500
        },
        luxe: {
          emiOnPDP: false,
          emiOnPayment: false,
          offerOrder: ['coupon', 'emiOffer', 'bankOffer'],
          thresholdAmount: 4500
        }
      },
      common: {
        startingInterestRateText: 'From @{num}% p.a',
        noCostEmiLabel: 'No Cost EMI',
        processingFeeInfo: 'A one-time processing fee of ₹{price} will be charged by the bank.',
        emiStartingFrom: 'starting from ₹{totalMonthlyAmountPayable}/month',
        noCostEmiCardsNotFoundMessage: 'No cards found with ‘No Cost EMI’',
        noCostEmiFilterHint:
          'Try turning off the filter to view all EMI options to explore other EMI plans.',
        searchedCardNotFoundMessage: 'No Card Found',
        searchedCardNotFoundHint: 'Try a different bank name or check your spelling',
        searchByBankNamePlaceholder: 'Search by your bank name',
        noCostEmiFilterLabel: 'Show only ‘No Cost EMI’ options',
        cashbackMessage: 'Get Flat ₹{amount} cashback with {bank}',
        tncMsg: "By placing this order, you agree to AJIO's T&C",
        installmentLabel: 'Installments',
        interestLabel: 'Interest',
        totalCost: 'Total Cost'
      },
      pdp: {
        emiTemplates: {
          GLOBAL_THRESHOLD: 'No EMI offers or plans available for this product.',
          STANDARD_EMI:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months) with {type} EMI on {issuerSlug} ({bankInterestRate}% p.a.)',
          ABOVE_THRESHOLD_NOCOST:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months) with {type} EMI on your {issuerSlug}',
          ABOVE_THRESHOLD_STANDARD_INSTANT:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months) with {type} EMI + {instantDiscountApplied}% Instant Discount on {issuerSlug}',
          ABOVE_THRESHOLD_STANDARD_CASHBACK:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months) with {type} EMI + ₹{cashbackApplied} Cashback on {issuerSlug}',
          ABOVE_THRESHOLD_NOCOST_INSTANT:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months) with {type} EMI + {instantDiscountApplied}% Instant Discount on {issuerSlug}',
          ABOVE_THRESHOLD_NOCOST_CASHBACK:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months) with {type} EMI + ₹{cashbackApplied} Cashback on {issuerSlug}',
          ABOVE_THRESHOLD_STANDARD_INSTANT_CASHBACK:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months) with {type} EMI + {instantDiscountApplied}% Instant Discount + ₹{cashbackApplied} Cashback on {issuerSlug}',
          LOW_THRESHOLD_NOCOST:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months)* – {type} EMI applicable only on purchases above ₹{thresholdAmount}',
          LOW_THRESHOLD_STANDARD_INSTANT:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months)* – Instant Discount applicable only on eligible items above ₹{thresholdAmount}',
          LOW_THRESHOLD_STANDARD_CASHBACK:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months)* – Cashback offer valid only for transactions above ₹{thresholdAmount}',
          LOW_THRESHOLD_NOCOST_INSTANT:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months)* – {type} EMI + Instant Discount available above ₹{thresholdAmount}',
          LOW_THRESHOLD_NOCOST_CASHBACK:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months)* – {type} EMI + Cashback offers apply on carts above ₹{thresholdAmount}',
          LOW_THRESHOLD_STANDARD_INSTANT_CASHBACK:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months)* – EMI offers (Instant Discount + Cashback) applicable above ₹{thresholdAmount}',
          LOW_THRESHOLD_NOCOST_INSTANT_CASHBACK:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months)* – {type} EMI + Instant Discount + Cashback available above ₹{thresholdAmount}',
          ABOVE_THRESHOLD_NOCOST_INSTANT_CASHBACK:
            '₹{totalMonthlyAmountPayable}/month ({tenure} months) with {type} EMI + {instantDiscountApplied}% Instant Discount + ₹{cashbackApplied} Cashback on {issuerSlug}'
        },
        emiPlanMessages: {
          instantDiscountMessage:
            'Upto ₹{instantDiscountApplied} instant discount with {tenure} month EMI',
          emiPlanLabel: 'EMI Plans'
        }
      },
      spc: {
        cardOffersUpdateMessage: 'Offers updated for your card',
        cardPlanInstantDiscount: 'Get flat ₹{price} off on {bank} on {tenure} months',
        confirmOrderRetryCount: 10,
        confirmOrderRetryDelayInMilliseconds: 3000,
        emiPlanLabel: 'EMI Plan',
        emiSubtitle: 'No Cost EMI Offer, Instant Discount, Low Interest Rate',
        instantDiscountMessage: '{discount}% instant discount with {bank}',
        interestRateInfo: 'Interest @{interest}% p.a',
        knowMoreLabel: 'Know More',
        mobileVerificationTitle: 'Verify Mobile Number',
        mobileVerificationBtn: 'VERIFY MOBILE NUMBER',
        moreEmiOptionsTitle: 'More EMI Options',
        notEligibleForDebitCard:
          "You're not eligible for Debit Card EMI. Try another number or payment method",
        mobileNumberValidationMsg: 'Please enter a valid 10-digit mobile number',
        mobileNumberValidationMsgDesktop:
          'Your mobile number should be of 10 digits. Please also ensure it does not start with 0 or +91.',
        offerSectionTitle: 'Offers',
        otherEMISectionTitle: 'Other EMI Options',
        otpSentInfo: 'OTP sent to your mobile number.',
        otpVerifyBtn: 'VERIFY',
        processingFeeLabel: 'Processing Fee',
        proceedWithEMIToastMsg: 'Choose EMI Plan to Proceed',
        proceedWithEmiTextSPC: 'Choose EMI Plan For ₹{amount}',
        proceedToEnterCardBtn: 'Proceed to Enter Card Detail',
        selectEmiPlanTitle: 'Choose EMI Plans',
        tenurePlanNote:
          '₹{price} will be blocked on your card now. It will be converted into EMI in 5-7 working days.',
        totalAmountLabel: 'Total Amount',
        viewMoreEmiOptionsText: 'View More EMI Options',
        viewLessEmiOptionsText: 'View Less EMI Options',
        availableOnOrdersText: 'Available on orders above ₹{amount}',
        noCostEmiDiscountTitle: 'No Cost EMI Discount',
        cardMismatchError: 'Card Number does not match with the bank you selected.',
        otpGenerateApiFailureMsg: 'Oops, Something went wrong, please try again later',
        noCostEmiUnavailableMsg: 'EMI not available on this order'
      }
    },
    ratingParityMsite: 'OFF',
    oosSimilarProduct: 'OFF',
    affiliateFeatureConfig: {
      masterFlag: false,
      attributionWindow: 24,
      showNewTag: false,
      affiliateIngressTitle: 'AJIO Creator Program',
      affiliateIngressSubtitle: 'Turn Style Into Earnings',
      cmsPageLink: ''
    },
    gstFeatureConfig: {
      gstConfig: {
        cart: {
          addressNoteMessage: 'Note: Both Billing and shipping addresses are required to proceed',
          adressCheckBoxLabel: 'Copy shipping address to billing address',
          allIneligibleItemsInCart: 'All items in your cart aren’t eligible for GST invoice.',
          allIneligibleItemsToastMsg: 'Non-GST items removed to from your cart',
          allIneligibleTitle: 'All items in your cart aren’t eligible for GST invoice.',
          autoFilledPanDetailsToastMsg: 'We’ve autofilled the previously used PAN details',
          checkBoxLabel: 'Use GST Invoice',
          confirmChangeAddressDescription:
            'By changing the address, you’ll need to re-validate it with your GST details to claim the benefits.',
          confirmChangeAddressTitle: 'Are you sure you want to change address?',
          deleteSavedGSTMsg:
            'Deleting this will erase all the stored data linked to this GST number.',
          deleteSavedGSTTitle: 'Are you sure you want to delete?',
          gstAppliedToOrderSuccessMessage: 'Success! GST verified and applied to your order.',
          gstPANAmountLimit: 5000,
          invalidGstinMessage: 'Please enter valid GST number.',
          maxProfileNote:
            'Note: A maximum of 5 GST entries is allowed. Please delete an existing GST entry to proceed.',
          maxProfileTooltip:
            'A maximum of 5 GST entries is allowed. Please delete an existing GST entry to add a new one.',
          movedToWishlistMsg: 'The product(s) has been successfully moved to your wishlist',
          noSavedGSTSubHeading:
            'Please add a new GST number to continue with GST invoice benefits.',
          noSavedGSTTitle: 'No Saved GST Details',
          panCardVerificationNote:
            'Note: Please make sure the “Business name on PAN Card” matches with your “GST business name”',
          panVerificationConsentURL: 'https://www.ajio.com/pancard-declaration',
          panVerificationSubHeading: 'For order total 2 Lakhs & above, PAN details are mandatory.',
          panVerificationTitle: 'PAN VERIFICATION',
          previewInelibileItemsNote:
            'Note: Non-GST items will be moved to your wishlist if you proceed with GST.',
          returnRefundPolicyMessage: 'Exchange not available for GST Orders',
          revalidateAddressError:
            'Address has been updated, re-validate your address to retain benefits.',
          revalidatingStateMessage: 'Re-validating the data with GST records…',
          savedGSTExpiredErrorMessage:
            'Your GST is expired. Kindly use different GST to avail the benefits.',
          sectionTitle: 'Save up to 24% with GST benefits',
          shippingPageAddressChangedMessage:
            'Your GST benefits require address re-validation due to a recent address change. Please re-validate the address to claim the benefits.',
          shippingPageAddressChangedTooltip:
            'Your address has been changed. Please re-validate the new address before proceeding with the payment.',
          someIneligibleItemsInCart: 'Some items in your cart aren’t eligible for GST invoice.',
          someIneligibleItemsToastMsg: 'Non-GST items removed to enable GST billing.',
          someIneligibleTitle: '{num} items in your cart aren’t eligible for GST invoice.',
          termsAndConditionURL: 'https://www.ajio.com/help/termsAndCondition',
          validateAddressSubHeading:
            'For GST benefits, the city and pincode must match your GST registered address.',
          validateGSTConsentMessage: 'Add & use this GST for all future orders.'
        },
        common: {
          billingAddressLabel: 'Billing Address:',
          gstExpiredTag: 'Expired',
          gstinLabel: 'GSTIN:',
          shippingAddressLabel: 'Shipping Address:'
        },
        odp: {
          businessCancellationMessage:
            'We had to cancel your order as the GST number provided was expired at the time of verification.',
          cancelError: 'Cancelled item will not be included in the GST invoice.',
          faqTitle: 'Frequently Asked Questions',
          faqs: [
            {
              answers: [
                '{DownloadInvoice} from here',
                'For returned items you will get Refund Credit Note against each returned item.',
                'Invoice won’t be available for the returned items.'
              ],
              question: 'How to download GST Invoice?'
            },
            {
              answers: [
                'It means your GST number has expired and needs to be reactivated on the Government GST portal.',
                'If your GST number is expired at the time of delivery or during a return, a regular invoice will be issued instead of a GST invoice.',
                'GST details will be re-verified once the product reaches our warehouse. If the GST number is inactive at that time, a regular invoice will be issued.'
              ],
              question: "What does 'GST expired' mean?"
            }
          ],
          faqs2: [
            {
              key: 'gst',
              title: 'GST Related Queries',
              questionAnswer: [
                {
                  answers: [
                    'Download Invoice from {here}',
                    'For returned items you will get Refund Credit Note against each returned item.',
                    'Invoice won’t be available for the returned items.'
                  ],
                  question: 'How to download GST Invoice?'
                },
                {
                  answers: [
                    'It means your GST number has expired and needs to be reactivated on the Government GST portal.',
                    'If your GST number is expired at the time of delivery or during a return, a regular invoice will be issued instead of a GST invoice.',
                    'GST details will be re-verified once the product reaches our warehouse. If the GST number is inactive at that time, a regular invoice will be issued.'
                  ],
                  question: "What does GST expired' mean?"
                }
              ]
            },

            {
              key: 'emi',
              title: 'GST & EMI Related Queries',
              questionAnswer: [
                {
                  answers: [
                    'No Cost EMI is a payment option that lets you buy a product in monthly instalments without paying any extra interest or fees—your total payment stays the same as the product’s original price.'
                  ],
                  question: 'What is EMI'
                },
                {
                  answers: [
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet elit eu sem feugiat venenatis vitae id elit. Proin eleifend nec neque ut porttitor.'
                  ],
                  question: 'Where can I find the EMI tenures and interest rates?'
                },
                {
                  answers: [
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet elit eu sem feugiat venenatis vitae id elit. Proin eleifend nec neque ut porttitor.'
                  ],
                  question: 'How can I use the No Cost EMI offer?'
                },
                {
                  answers: [
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet elit eu sem feugiat venenatis vitae id elit.'
                  ],
                  question: 'What is pre-approved EMI?'
                },
                {
                  answers: [
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet elit eu sem feugiat venenatis vitae id elit.'
                  ],
                  question: 'How do I know if I am eligible for a pre-approved EMI?'
                },
                {
                  answers: [
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet elit eu sem feugiat venenatis vitae id elit.'
                  ],
                  question: 'What is Debit Card EMI?'
                }
              ]
            },

            {
              key: 'bankDiscount',
              title: 'GST & Bank Discount Queries',
              questionAnswer: [
                {
                  answers: ['Return or cancellation reduces the order amount.'],
                  question: 'How this bank discount will be impacted?'
                },
                {
                  answers: [
                    'If the order value falls below the minimum required to avail the bank discount, the discount will be deducted upon cancellation or return.'
                  ],
                  question: 'How it is calculated?'
                },
                {
                  answers: [
                    'Deduction of discount amount will happen from the item being returned or canceled under the same Order ID.'
                  ],
                  question: 'On which product it will be deducted?'
                },
                {
                  answers: [
                    'User will receive no refund, if the item price is lower than the availed bank discount'
                  ],
                  question: 'Will I get a refund if the item price is lower than the discount?'
                }
              ]
            },

            {
              key: 'all',
              title: 'GST,EMI & Bank Discount Queries',
              questionAnswer: [
                {
                  answers: ['Return or cancellation reduces the order amount.'],
                  question: 'How this bank discount will be impacted?'
                },
                {
                  answers: [
                    'If the order value falls below the minimum required to avail the bank discount, the discount will be deducted upon cancellation or return.'
                  ],
                  question: 'How it is calculated?'
                },
                {
                  answers: [
                    'Deduction of discount amount will happen from the item being returned or canceled under the same Order ID.'
                  ],
                  question: 'On which product it will be deducted?'
                },
                {
                  answers: [
                    'User will receive no refund, if the item price is lower than the availed bank discount'
                  ],
                  question: 'Will I get a refund if the item price is lower than the discount?'
                }
              ]
            }
          ],

          generalMessage: [
            'GST invoice will be issued only if GST is valid at the time of delivery/return.',
            'Cancelled items are not eligible for GST invoices.'
          ],
          gstExpiredError: 'Your GST is expired. A regular invoice will be issued for this order.',
          gstDetailsTitle: 'GST Details',
          moreInfoTitle: 'More Info',
          returnNote:
            'Note: GST details will be re-verified once the product reaches our warehouse.',
          selectAddressWarning: 'Address change is not allowed for GST orders'
        }
      },
      masterFlag: true,
      platforms: {
        ajio: {
          cohorts_exclusion: []
        },
        ajiogram: {
          cohorts_exclusion: []
        },
        luxe: {
          cohorts_exclusion: []
        }
      }
    },
    crossSellV2: {
      pdp: { title: 'Style this Top with', isEnabled: false },
      master: false
    },
    trendBasedDiscoveryConfig: {
      pdp: {
        title: 'Vibe Match',
        subTitle: 'Curated to match the vibe',
        isEnabled: false,
        vibeQuery: ':relevance:vibe:',
        tagIconAjio: 'https://ibb.co/Y77VmvM0',
        tagIconLuxe:
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-icons/Frame_2147225749Luxe.png',
        trendsQuery: ':relevance:trend:'
      },
      plp: {
        ajio: {
          gradientEnd: '#FFDFCB',
          gradientStart: '#FFFFFF'
        },
        luxe: {
          gradientEnd: '#E2E2E2',
          gradientStart: '#FFFFFF'
        },
        ajiogram: {
          gradientEnd: '#24253B',
          gradientStart: '#060C10'
        },
        isEnabled: false
      },
      home: {
        segments: ['men', 'women', 'kids'],
        isEnabled: false,
        clip_images: [
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number.png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(1).png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(2).png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(3).png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(4).png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(5).png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(6).png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(7).png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(8).png',
          'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/trending-widget-clip-images/Trend_Number_(9).png'
        ]
      },
      master: false,
      maxTrendsCount: 10,
      isForceStoreAjio: false
    },
    visualfiltersconfig: {
      master: false,
      stores: {
        ajio: {
          master: false,
          inlineFilterEnabled: false,
          compoundFilterEnabled: false,
          quickFilters: false
        },
        luxe: {
          master: false,
          inlineFilterEnabled: false,
          compoundFilterEnabled: false,
          quickFilters: false
        },
        ajiogram: {
          master: false,
          inlineFilterEnabled: false,
          compoundFilterEnabled: false,
          quickFilters: false
        }
      },
      filterIcons: {
        new: 'https://assets.ajio.com/cms/AJIO/MOBILE/New.png',
        bestprice: 'https://assets.ajio.com/cms/AJIO/MOBILE/Best_Price_2x.png',
        exclusive: 'https://assets.ajio.com/cms/AJIO/MOBILE/Exclusive.png',
        bestseller: 'https://assets.ajio.com/cms/AJIO/MOBILE/BestSeller.png',
        sellingfast: 'https://assets.ajio.com/cms/AJIO/MOBILE/SellingFast.png'
      },
      inlineFilter: {
        title: 'Quick filters for you',
        position: 6,
        autoSkip: false
      },
      inlineFilterOrder: ['TagsFilters', 'GenderFilters', 'BrandFilters', 'ColorFilters'],
      quickFilterOrder: [
        {
          code: 'allfilters',
          name: 'Filter',
          tabPosition: 0
        },
        {
          code: 'sla',
          name: 'SLA',
          tabPosition: 1
        },
        {
          code: 'l1l3nestedcategory',
          name: 'Category',
          tabPosition: 2
        },
        {
          code: 'genderfilter',
          name: 'Gender',
          tabPosition: 3
        },
        {
          code: 'pricerange',
          name: 'Price',
          tabPosition: 4
        },
        {
          code: 'brand',
          name: 'Brands',
          tabPosition: 5
        },
        {
          code: 'occasion',
          name: 'Occasion',
          tabPosition: 6
        },
        {
          code: 'verticalcolorfamily',
          name: 'Colors',
          tabPosition: 7
        },
        {
          code: 'tags',
          name: 'Tags',
          tabPosition: 8
        }
      ]
    },
    enableBestCouponOnCart: 'OFF',
    customer_celebration_config: {
      enabled: false,
      orderListing: {
        enabled: false,
        title: {
          QUICK_PICKUP: 'Quick Pickup',
          QUICK_DELIVERY: 'Quick Delivery',
          SUPERSONIC_PICKUP: 'Supersonic Pickup',
          SUPERSONIC_DELIVERY: 'Supersonic Delivery',
          QUICK_REFUND_INITIATION: 'Quick Refund Initiation',
          LIGHTNING_REFUND_INITIATION: 'Lightning Refund Initiation'
        },
        animation: {
          QUICK_PICKUP:
            'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/lottie-jsons/OrderCelebartions/home.json',
          QUICK_DELIVERY: 'https://assets-uat.ajio.ril.com/cms/AJIO/MOBILE/delivery_tag.svg%27',
          SUPERSONIC_PICKUP:
            'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/lottie-jsons/OrderCelebartions/home.json',
          SUPERSONIC_DELIVERY:
            'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/lottie-jsons/OrderCelebartions/home.json',
          QUICK_REFUND_INITIATION:
            'https://cdn.pixelbin.io/v2/dry-wildflower-b77541/original/lottie-jsons/OrderCelebartions/home.json',
          LIGHTNING_REFUND_INITIATION:
            'https://assets-uat.ajio.ril.com/cms/AJIO/MOBILE/delivery_tag.svg'
        }
      }
    },
    cancel_refund_improvement_config: {
      master: false,
      cancel: {
        enableSticky: false,
        refundBreakup: false
      },
      return: {
        enableSticky: false
      }
    },
    olp_filter_improvement: {
      master: false,
      filters: {
        returns: 'Returns',
        cancelled: 'Cancelled',
        delivered: 'Delivered',
        order_confirmed: 'Confirmed'
      }
    },
    enableNonReturnableProductRevamp: {
      isEnabled: false,
      daysReturnMsite: '%x-Day Return',
      daysReturnDesktop: '%x-Day Return',
      daysExchangeMsite: '%x-Day Exchange',
      daysExchangeDesktop: '%x-Day Exchange',
      returnAndExchangeAvailableMsite: '%x-Day Return and Exchange',
      returnAndExchangeAvailableDesktop: '%x-Day Return and Exchange',
      noReturnMsite: 'Non Returnable',
      noReturnDesktop: 'Non Returnable',
      noExchangeMsite: 'No Exchange',
      noExchangeDesktop: 'No Exchange',
      noReturnAndExchangeMsite: 'No Return and Exchange',
      noReturnAndExchangeDesktop: 'No Return and Exchange',
      nonReturnableMsite: '(Non Returnable)',
      nonReturnableDesktop: '(Non Returnable)'
    }
  }
};
